var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 443,
    viewBox: "0 0 621 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7478 444.983C25.8633 446.719 23.5393 448.03 20.7531 447.869C18.1397 447.717 16.1667 446.426 15.9631 444.774C15.743 442.979 17.7094 441.54 20.4373 441.583C23.065 441.626 25.6322 443.249 25.7478 444.983Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.471 440.352C612.806 438.96 613.181 439.258 612.312 441.084C611.474 442.847 609.653 445.517 608.298 446.967C606.877 448.489 606.447 448.041 607.424 446.123C608.358 444.291 610.162 441.72 611.471 440.352Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.185 439.51C120.775 439.747 123.684 441.257 123.804 442.968C123.933 444.794 120.629 446.091 116.909 445.716C113.554 445.377 110.677 443.67 110.734 442.074C110.793 440.431 113.656 439.278 117.185 439.51Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9167 433.921C78.5075 434.198 81.2936 435.713 81.3171 437.437C81.3406 439.098 78.4866 440.319 75.0383 440.168C71.4141 440.008 68.0364 438.117 68.2528 436.399C68.46 434.764 71.4056 433.651 74.9167 433.921Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7432 434.735C42.6262 436.385 40.0176 437.577 37.1137 437.355C34.2559 437.138 31.7098 435.524 31.6366 433.917C31.5539 432.108 34.3042 430.792 37.5777 431.137C40.6033 431.458 42.8648 433.015 42.7432 434.735Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0582 432.954C10.1694 434.634 8.0812 435.983 5.48644 435.982C2.76806 435.982 0.180693 434.228 0.25855 432.491C0.333922 430.835 2.44062 429.574 5.06878 429.689C7.76369 429.806 9.94452 431.213 10.0582 432.954Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0574 411.311C10.1709 413.035 8.2802 414.417 6.11199 414.272C4.20022 414.143 2.41671 412.702 2.2359 411.179C2.02887 409.44 3.62005 407.955 5.7599 407.983C7.86921 408.008 9.94388 409.593 10.0574 411.311Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4616 414.975C34.4326 414.861 31.7188 413.22 31.6369 411.488C31.5612 409.888 33.5367 408.689 36.3572 408.682C39.282 408.675 42.4079 410.289 42.7203 411.997C43.0367 413.719 40.5626 415.089 37.4616 414.975Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3151 416.539C81.3837 418.248 78.6702 419.457 75.6049 419.126C72.8803 418.834 70.4151 417.278 70.2184 415.75C69.9922 413.986 72.3083 412.693 75.4114 412.903C78.4185 413.108 81.2464 414.836 81.3151 416.539Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.767 420.795C125.838 422.494 122.654 423.674 119.053 423.318C115.881 423.005 112.936 421.405 112.711 419.888C112.453 418.158 115.256 416.87 118.846 417.111C122.386 417.35 125.698 419.101 125.767 420.795Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.733 428.94C160.992 428.664 157.742 426.892 157.801 425.185C157.856 423.607 160.463 422.543 163.98 422.696C167.626 422.853 171.31 424.606 171.519 426.298C171.731 428.006 168.562 429.224 164.733 428.94Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.595 431.398C218.53 433.088 215.101 434.208 211.325 433.797C208.012 433.435 204.995 431.785 204.872 430.278C204.732 428.553 207.803 427.326 211.585 427.628C215.336 427.927 218.659 429.707 218.595 431.398Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.31 437.028C266.15 438.715 262.642 439.818 258.873 439.388C255.553 439.01 252.626 437.355 252.588 435.847C252.543 434.127 255.714 432.914 259.493 433.233C263.218 433.546 266.469 435.349 266.31 437.028Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.677 441.902C314.44 443.59 310.884 444.71 307.122 444.293C303.819 443.927 300.935 442.271 300.962 440.767C300.994 439.041 304.227 437.822 308.009 438.127C311.758 438.431 314.914 440.212 314.677 441.902Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.876 437.242C602.439 438.651 600.649 440.793 599.093 441.79C597.737 442.655 596.834 442.336 597.157 441.147C597.533 439.764 599.119 437.732 600.708 436.635C602.256 435.564 603.311 435.836 602.876 437.242Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.575 420.165C622.089 418.663 622.979 418.907 622.416 420.723C621.853 422.542 619.984 425.423 618.478 426.812C617.138 428.048 616.389 427.757 616.829 426.212C617.336 424.436 619.02 421.707 620.575 420.165Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7281 425.458C18.0321 425.244 15.944 423.694 15.9463 421.962C15.9486 420.223 18.04 418.994 20.7642 419.205C23.3992 419.408 25.7754 421.074 25.7517 422.743C25.7269 424.426 23.3755 425.669 20.7281 425.458Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.411 422.757C59.4043 423.118 61.9393 424.916 61.689 426.537C61.4281 428.228 58.7388 429.275 55.7069 428.909C52.6534 428.54 50.4158 426.878 50.6041 425.16C50.7923 423.44 53.2993 422.381 56.411 422.757Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3361 431.738C92.6956 431.444 89.867 429.868 89.8154 428.133C89.7638 426.406 92.5773 425.235 96.1871 425.524C99.7014 425.806 102.834 427.5 102.888 429.171C102.942 430.844 99.8786 432.024 96.3361 431.738Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.042 437.297C136.283 436.89 133.451 435.208 133.621 433.509C133.791 431.802 136.908 430.762 140.727 431.171C144.421 431.566 147.542 433.363 147.332 434.994C147.117 436.643 143.736 437.698 140.042 437.297Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.509 436.068C190.201 436.465 193.289 438.248 193.092 439.887C192.893 441.536 189.514 442.597 185.82 442.195C182.054 441.785 179.21 440.104 179.38 438.411C179.551 436.712 182.714 435.661 186.509 436.068Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.792 445.575C240.431 447.207 236.934 448.222 233.261 447.777C229.513 447.323 226.797 445.613 227.12 443.926C227.442 442.234 230.708 441.238 234.505 441.691C238.206 442.134 241.151 443.947 240.792 445.575Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.484 444.784C601.941 446.302 601.278 446.055 601.897 444.256C602.501 442.5 604.206 439.857 605.698 438.369C607.168 436.901 607.939 437.084 607.355 438.816C606.779 440.52 604.952 443.338 603.484 444.784Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.258 427.834C620.769 429.448 620.213 429.342 620.948 427.631C621.669 425.953 623.43 423.304 624.874 421.715C626.292 420.152 626.916 420.21 626.227 421.862C625.546 423.491 623.687 426.287 622.258 427.834Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.941 417.812C614.508 416.741 615.545 416.854 615.378 418.115C615.199 419.477 613.603 421.603 611.935 422.727C610.297 423.833 609.196 423.491 609.593 422.05C609.966 420.708 611.43 418.845 612.941 417.812Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.108 432.46C594.922 433.831 593.502 435.788 592.013 436.759C590.357 437.838 589.096 437.464 589.261 435.998C589.423 434.56 591.026 432.461 592.694 431.536C594.241 430.678 595.297 431.057 595.108 432.46Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.497 441.774C572.033 441.208 573.086 441.915 572.878 443.462C572.65 445.148 570.988 447.135 569.345 447.725C567.898 448.244 566.865 447.415 567.041 445.955C567.235 444.344 568.842 442.382 570.497 441.774Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.045 443.011C430.915 444.648 428.095 445.888 424.777 445.774C421.084 445.646 417.933 443.99 417.977 442.204C418.018 440.464 421.453 439.194 425.197 439.537C428.678 439.853 431.178 441.338 431.045 443.011Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.25 439.607C387.182 441.236 384.411 442.429 381.095 442.266C377.406 442.084 374.205 440.389 374.178 438.608C374.15 436.876 377.521 435.66 381.274 436.055C384.762 436.424 387.32 437.941 387.25 439.607Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.48 431.144C337.489 431.52 340.524 433.305 340.154 435.076C339.821 436.672 336.735 437.657 333.182 437.314C329.334 436.944 326.134 435.054 326.483 433.366C326.8 431.831 329.979 430.816 333.48 431.144Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.34 431.018C282.501 430.658 279.202 428.783 279.399 427.089C279.578 425.567 282.699 424.521 286.167 424.838C290.146 425.202 293.341 427.001 293.106 428.757C292.893 430.339 289.854 431.349 286.34 431.018Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.587 419.26C240.303 419.638 243.176 421.128 243.42 422.816C243.683 424.636 240.542 425.813 236.601 425.398C232.726 424.99 229.45 423.082 229.724 421.406C229.979 419.848 233.001 418.894 236.587 419.26Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.499 420.524C184.659 420.181 181.263 418.325 181.335 416.626C181.4 415.096 184.404 414.032 187.871 414.332C191.849 414.676 195.162 416.462 195.059 418.226C194.968 419.816 192.017 420.839 188.499 420.524Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.695 408.747C144.203 409.094 147.038 410.594 147.319 412.275C147.625 414.098 144.657 415.299 140.909 414.907C137.548 414.557 134.641 412.994 134.298 411.372C133.928 409.624 136.925 408.376 140.695 408.747Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.884 408.409C102.75 410.02 99.9297 411.034 96.5337 410.728C92.8429 410.395 89.6567 408.54 89.8208 406.851C89.9914 405.086 93.1736 404.087 97.0227 404.631C100.367 405.103 103.019 406.8 102.884 408.409Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.572 406.564C53.4656 406.375 50.6462 404.635 50.5932 402.907C50.5462 401.352 52.8538 400.136 55.6451 400.295C58.8469 400.478 61.6624 402.164 61.7049 403.959C61.7435 405.578 59.4176 406.737 56.572 406.564Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.961 396.82C23.5191 397.08 25.6582 398.592 25.7489 400.247C25.848 402.061 23.4379 403.346 20.6542 403.034C18.2023 402.759 16.0452 401.169 15.9498 399.607C15.8435 397.863 18.1689 396.535 20.961 396.82Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.519 441.369C541.399 443.085 539.918 444.438 538.266 444.38C536.603 444.321 535.52 442.887 535.654 441.071C535.781 439.323 537.14 437.973 538.719 438.089C540.318 438.205 541.636 439.673 541.519 441.369Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.098 436.165C563.106 437.778 561.656 439.606 560.044 440.065C558.39 440.536 557.182 439.521 557.216 437.804C557.248 436.122 558.585 434.388 560.138 433.975C561.681 433.562 563.091 434.547 563.098 436.165Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.036 425.816C584.574 425.071 585.955 425.596 585.979 427.096C586 428.596 584.578 430.61 582.956 431.418C581.296 432.245 580.074 431.606 580.095 430.005C580.119 428.434 581.472 426.574 583.036 425.816Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.881 415.734C606.717 417.244 605.239 419.198 603.581 420.122C601.915 421.051 600.856 420.529 601.032 418.934C601.203 417.401 602.739 415.576 604.309 414.734C605.895 413.882 607.044 414.242 606.881 415.734Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.121 404.386C621.647 405.574 620.568 405.407 620.628 404.038C620.685 402.691 622.015 400.823 623.405 399.717C624.777 398.625 625.866 398.543 625.855 399.826C625.842 401.11 624.572 403.218 623.121 404.386Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.991 439.414C517.923 441.083 516.046 442.393 513.872 442.273C511.654 442.153 510.016 440.699 510.157 438.966C510.294 437.286 512.018 435.859 514.063 435.989C516.129 436.119 518.06 437.748 517.991 439.414Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.919 437.519C487.806 439.167 485.433 440.373 482.724 440.156C479.959 439.934 477.939 438.419 478.129 436.708C478.314 435.047 480.42 433.682 482.973 433.905C485.551 434.131 488.03 435.871 487.919 437.519Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.314 434.677C451.388 436.345 448.875 437.562 445.773 437.36C442.608 437.156 440.19 435.682 440.202 433.965C440.214 432.26 442.353 430.912 445.335 431.099C448.241 431.282 451.241 433.024 451.314 434.677Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.782 431.295C410.895 432.952 407.954 434.107 404.307 433.845C400.586 433.576 397.729 432.065 397.711 430.36C397.693 428.666 400.25 427.366 403.759 427.612C407.179 427.853 410.672 429.653 410.782 431.295Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.345 426.871C363.994 428.488 360.817 429.345 357.113 428.834C353.413 428.321 350.959 426.684 351.336 424.987C351.702 423.343 354.705 422.282 358.225 422.825C361.768 423.372 364.689 425.283 364.345 426.871Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.933 421.324C317.595 422.924 314.254 423.757 310.385 423.219C306.504 422.678 303.903 421.019 304.264 419.329C304.614 417.697 307.868 416.672 311.554 417.24C315.262 417.813 318.267 419.745 317.933 421.324Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.931 414.829C268.918 416.439 265.699 417.414 261.906 416.977C258.044 416.531 255.12 414.884 255.205 413.216C255.288 411.598 258.527 410.44 262.099 410.872C265.72 411.309 268.943 413.22 268.931 414.829Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.594 409.173C218.678 410.784 215.493 411.8 211.721 411.39C207.863 410.97 204.872 409.335 204.867 407.658C204.864 406.023 208.12 404.857 211.709 405.263C215.303 405.67 218.511 407.564 218.594 409.173Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.563 404.223C169.686 405.845 166.681 406.887 163.09 406.501C159.415 406.104 156.541 404.48 156.494 402.793C156.448 401.146 159.615 399.971 163.034 400.354C166.456 400.738 169.443 402.602 169.563 404.223Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.801 399.944C123.963 401.578 120.98 402.665 117.39 402.317C113.713 401.962 110.819 400.359 110.735 398.658C110.653 396.998 113.875 395.796 117.292 396.141C120.715 396.488 123.64 398.31 123.801 399.944Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.306 394.204C81.5002 395.849 78.9828 397.018 75.9398 396.742C72.819 396.46 70.3297 394.899 70.2074 393.179C70.0878 391.494 72.8072 390.244 75.7312 390.521C78.6357 390.796 81.1119 392.554 81.306 394.204Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8625 393.97C34.0809 393.816 31.8476 392.366 31.6468 390.62C31.4495 388.893 33.7035 387.552 36.3211 387.692C38.8733 387.83 41.1377 389.483 41.4153 391.151C41.6966 392.839 39.5823 394.119 36.8625 393.97Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09649 389.02C8.21272 390.692 6.39457 391.998 4.23106 391.874C2.01728 391.747 0.309731 390.294 0.25835 388.549C0.206903 386.848 2.09886 385.46 4.15281 385.591C6.21015 385.721 7.98137 387.347 8.09649 389.02Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.318 427.898C551.49 429.37 550.08 430.955 548.517 431.073C547.079 431.183 545.765 430.105 545.504 428.714C545.198 427.084 546.183 425.715 547.858 425.505C549.485 425.301 551.144 426.391 551.318 427.898Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.221 427.394C570.66 427.981 569.145 427.121 568.996 425.659C568.856 424.296 569.806 422.858 571.277 422.252C572.883 421.589 574.566 422.18 574.833 423.583C575.089 424.923 573.786 426.806 572.221 427.394Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.088 412.251C597.178 413.695 595.711 415.916 594.141 416.73C592.698 417.481 591.421 416.982 591.236 415.662C591.019 414.115 592.107 412.227 593.794 411.269C595.429 410.342 596.995 410.774 597.088 412.251Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.702 398.042C616.666 399.423 615.264 401.676 613.88 402.585C612.4 403.555 611.369 403.055 611.482 401.5C611.584 400.108 612.633 398.41 614.002 397.424C615.464 396.371 616.74 396.637 616.702 398.042Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.429 430.459C528.644 431.933 527.352 433.282 525.794 433.177C524.363 433.079 522.944 431.843 522.639 430.444C522.284 428.805 523.314 427.561 524.976 427.582C526.598 427.605 528.208 428.94 528.429 430.459Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.627 428.241C501.869 429.904 500.097 431.293 498.001 431.055C496.076 430.834 494.233 429.367 493.878 427.79C493.463 425.943 494.869 424.647 497.099 424.792C499.264 424.934 501.381 426.538 501.627 428.241Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.905 426.085C469.346 427.738 467.279 429.152 464.668 428.965C462.313 428.796 459.849 427.315 459.301 425.757C458.653 423.919 460.283 422.583 463.025 422.687C465.714 422.79 468.447 424.36 468.905 426.085Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.99 420.586C431.46 422.233 429.075 423.591 426.112 423.356C423.447 423.143 420.67 421.62 420.082 420.067C419.386 418.229 421.255 416.939 424.371 417.095C427.417 417.249 430.499 418.866 430.99 420.586Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.894 418.117C388.124 419.753 384.964 420.921 381.452 420.492C378.226 420.098 375.303 418.514 374.891 416.955C374.409 415.13 376.903 413.996 380.631 414.344C384.246 414.681 387.657 416.442 387.894 418.117Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.8 412.36C341.212 414 338.246 415.258 334.736 414.929C331.573 414.633 328.43 413.06 327.875 411.512C327.22 409.685 329.557 408.465 333.239 408.714C336.847 408.96 340.371 410.649 340.8 412.36Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.115 406.308C293.226 407.934 289.935 409.045 286.421 408.57C283.194 408.133 280.371 406.527 280.074 404.976C279.728 403.16 282.322 402.066 286.058 402.461C289.68 402.845 293.001 404.643 293.115 406.308Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.671 399.19C231.589 397.447 234.528 396.415 238.214 396.902C241.82 397.379 244.895 399.239 244.737 400.878C244.601 402.302 241.681 403.314 238.536 403.034C235.046 402.725 231.749 400.868 231.671 399.19Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.988 394.319C181.964 392.573 184.944 391.524 188.629 391.996C192.235 392.459 195.266 394.313 195.051 395.955C194.864 397.383 191.891 398.408 188.744 398.14C185.25 397.843 182.01 395.999 181.988 394.319Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.603 387.748C144.23 388.096 147.413 389.883 147.34 391.556C147.268 393.189 143.781 394.329 140.273 393.885C137.041 393.476 134.399 391.906 134.273 390.345C134.125 388.523 136.859 387.389 140.603 387.748Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.883 385.908C102.743 387.553 99.7081 388.719 96.7435 388.294C94.0124 387.902 91.8113 386.336 91.7767 384.788C91.7342 382.967 94.1281 381.805 97.3064 382.139C100.39 382.463 103.027 384.23 102.883 385.908Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0817 385.538C52.378 385.23 50.3665 383.509 50.613 381.761C50.8398 380.156 52.799 379.116 55.3223 379.303C58.0567 379.505 60.4545 381.179 60.397 382.885C60.3434 384.535 57.6978 385.835 55.0817 385.538Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7277 378.768C25.45 380.436 22.6228 381.683 20.0459 381.318C17.2926 380.928 15.5682 379.254 16.0171 377.477C16.4207 375.886 18.5174 374.885 21.0696 375.115C23.7957 375.359 26.0092 377.07 25.7277 378.768Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.662 417.091C536.205 417.215 537.789 418.449 538.172 419.949C538.556 421.456 537.618 422.688 536.116 422.682C534.498 422.676 532.7 421.099 532.418 419.515C532.154 418.032 533.12 416.971 534.662 417.091Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.809 413.66C558.339 413.316 559.947 414.134 560.373 415.562C560.853 417.17 559.717 418.847 557.969 419.144C556.455 419.4 554.953 418.339 554.654 416.899C554.355 415.461 555.324 413.994 556.809 413.66Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.736 411.857C580.23 412.568 578.683 412.067 578.245 410.79C577.813 409.53 578.682 407.806 580.155 407.043C581.886 406.145 583.616 406.592 583.961 408.106C584.269 409.459 583.269 411.133 581.736 411.857Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.803 397.723C607.203 398.852 606.288 400.61 604.774 401.64C603.09 402.787 601.371 402.567 601.059 401.227C600.783 400.034 601.79 398.314 603.304 397.41C604.872 396.473 606.4 396.589 606.803 397.723Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.629 385.457C622.279 386.601 620.943 386.539 620.673 385.362C620.403 384.196 621.297 382.223 622.641 381.018C624.185 379.631 625.671 379.625 625.839 381.057C625.991 382.345 625.022 384.277 623.629 385.457Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.656 418.084C515.041 419.585 513.755 420.689 511.719 420.574C509.538 420.45 507.125 418.757 506.9 417.204C506.687 415.739 508.161 414.793 510.258 415.015C512.317 415.232 514.273 416.591 514.656 418.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.253 416.845C485.64 418.338 483.934 419.359 481.355 419.157C478.6 418.941 475.683 417.184 475.512 415.651C475.35 414.202 477.267 413.337 479.902 413.644C482.492 413.945 484.87 415.362 485.253 416.845Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.622 414.042C449.12 415.517 447.185 416.558 444.287 416.356C441.093 416.134 437.875 414.45 437.606 412.876C437.361 411.441 439.536 410.536 442.459 410.84C445.411 411.148 448.118 412.547 448.622 414.042Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.839 408.657C407.109 410.126 405.009 411.035 402.055 410.719C398.9 410.382 395.761 408.547 395.75 407.051C395.74 405.636 398.041 404.878 401.04 405.296C403.987 405.707 406.572 407.197 406.839 408.657Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.937 405.809C354.516 405.475 351.276 404.002 350.727 402.544C350.11 400.91 353.012 399.916 356.95 400.407C360.437 400.841 363.433 402.339 363.699 403.798C363.966 405.258 361.419 406.149 357.937 405.809Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.996 398.316C316.075 399.756 313.393 400.576 309.88 400.184C306.11 399.765 302.693 397.9 302.936 396.414C303.165 395.016 305.989 394.347 309.557 394.846C313.028 395.331 315.915 396.878 315.996 398.316Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.285 393.186C266.627 394.648 264.072 395.613 260.618 395.333C256.773 395.019 253.277 393.314 253.241 391.753C253.21 390.352 256.016 389.495 259.427 389.869C262.913 390.251 265.938 391.707 266.285 393.186Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.219 386.118C219.555 387.602 217.029 388.589 213.548 388.344C209.672 388.071 206.205 386.409 206.174 384.831C206.148 383.426 208.974 382.515 212.345 382.851C215.811 383.198 218.885 384.652 219.219 386.118Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.496 381.128C171.845 382.621 169.304 383.654 165.812 383.459C161.924 383.241 158.504 381.634 158.455 380.023C158.412 378.589 161.198 377.638 164.611 377.938C168.147 378.248 171.145 379.629 171.496 381.128Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.807 375.694C123.782 377.17 121.376 378.113 118.403 377.831C115.191 377.528 112.418 375.764 112.716 374.244C112.995 372.825 115.532 371.995 118.5 372.372C121.469 372.75 123.831 374.218 123.807 375.694Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9014 369.51C79.8646 369.727 82.4128 371.084 82.6109 372.573C82.8351 374.254 80.1039 375.371 76.7406 375.017C73.8159 374.707 71.4554 373.237 71.5122 371.789C71.5678 370.347 74.0153 369.298 76.9014 369.51Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7401 369.239C42.5904 370.733 40.3636 371.749 37.7475 371.56C34.9452 371.358 32.6061 369.641 32.9822 368.105C33.3378 366.655 35.614 365.748 38.2628 366.036C40.8631 366.318 42.8898 367.752 42.7401 369.239Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0553 366.283C9.92746 367.788 8.13049 368.879 6.04085 368.774C3.80249 368.662 1.95093 367.02 2.24948 365.464C2.53175 363.995 4.34147 363.004 6.46484 363.208C8.55102 363.408 10.183 364.785 10.0553 366.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.276 405.182C543.807 405.195 545.511 406.414 545.987 407.942C546.452 409.435 545.462 410.817 543.967 410.781C542.416 410.746 540.783 409.412 540.333 407.928C539.888 406.453 540.788 405.17 542.276 405.182Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.105 404.091C568.73 405.52 567.994 407.206 566.518 407.797C565.103 408.362 563.263 407.567 562.674 406.202C562.058 404.784 562.724 403.187 564.209 402.584C565.629 402.009 567.496 402.698 568.105 404.091Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.742 395.353C592.21 396.641 591.262 398.502 589.777 399.237C588.257 399.988 586.562 399.463 586.099 398.161C585.642 396.862 586.528 395.094 588.027 394.346C589.528 393.597 591.266 394.04 591.742 395.353Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.847 385.039C609.462 385.953 607.999 385.678 607.634 384.485C607.272 383.303 608.133 381.449 609.463 380.554C610.835 379.633 612.302 379.841 612.693 381.061C613.072 382.244 612.18 384.161 610.847 385.039Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.389 408.125C522.948 409.615 522.156 410.871 520.687 410.777C519.199 410.681 517.391 409.272 516.853 407.796C516.311 406.319 517.135 405.109 518.604 405.185C520.059 405.26 521.825 406.626 522.389 408.125Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.557 406.082C496.254 407.595 495.149 408.792 493.142 408.673C491.157 408.555 488.769 407.108 488.115 405.64C487.447 404.139 488.569 402.993 490.587 403.087C492.538 403.177 494.864 404.572 495.557 406.082Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.31 403.571C462.909 405.032 461.146 406.121 458.616 405.836C455.976 405.538 453.28 404.032 452.723 402.558C452.174 401.107 453.936 400.059 456.458 400.322C459.023 400.589 461.694 402.064 462.31 403.571Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.275 396.873C421.232 397.28 424.032 398.828 424.463 400.313C424.884 401.766 422.591 402.707 419.658 402.276C416.617 401.83 413.776 400.245 413.433 398.818C413.092 397.401 415.401 396.478 418.275 396.873Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.906 395.178C382.531 396.675 380.559 397.716 377.615 397.438C374.698 397.164 371.571 395.601 371.009 394.154C370.435 392.675 372.392 391.67 375.35 391.921C378.208 392.164 381.284 393.684 381.906 395.178Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.238 386.341C332.113 386.646 335.091 388.221 335.547 389.689C336.006 391.159 333.837 392.15 330.888 391.816C327.932 391.481 324.943 389.887 324.544 388.446C324.141 386.994 326.3 386.026 329.238 386.341Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.861 384.202C288.201 385.643 285.353 386.592 281.915 386.189C278.33 385.767 275.103 384.189 274.832 382.742C274.565 381.316 277.362 380.387 280.788 380.767C284.271 381.153 287.51 382.718 287.861 384.202Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.82 378.023C240.916 379.474 237.854 380.334 234.354 379.845C230.756 379.342 227.756 377.734 227.747 376.321C227.739 374.919 230.798 374.054 234.218 374.501C237.677 374.953 240.721 376.568 240.82 378.023Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.447 373.095C192.457 374.55 189.785 375.425 186.811 374.951C183.755 374.465 181.273 372.866 181.335 371.451C181.399 370.043 184.059 369.159 186.965 369.591C189.907 370.027 192.437 371.635 192.447 373.095Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.507 363.921C142.424 364.176 145.189 365.716 145.37 367.204C145.55 368.691 143.113 369.718 140.13 369.433C137.161 369.15 134.401 367.593 134.272 366.148C134.14 364.682 136.522 363.661 139.507 363.921Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.889 363.085C102.866 364.542 100.112 365.56 97.1941 365.214C94.1603 364.855 91.6945 363.323 91.7782 361.876C91.8632 360.443 94.527 359.426 97.438 359.738C100.428 360.061 102.912 361.575 102.889 363.085Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.349 358.502C62.5196 360.063 60.4611 361.196 57.7502 361.073C55.1785 360.955 52.6964 359.503 52.5604 358.057C52.4173 356.546 54.4281 355.398 57.1246 355.487C59.7002 355.571 62.1843 356.994 62.349 358.502Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7464 355.571C25.8581 357.136 24.1815 358.33 22.0118 358.28C19.9559 358.234 18.0007 356.846 17.9111 355.396C17.8171 353.884 19.4339 352.667 21.5948 352.682C23.6584 352.694 25.638 354.059 25.7464 355.571Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.087 399.64C530.858 401.117 530.198 402.476 528.787 402.376C527.341 402.27 525.546 400.827 524.825 399.228C524.18 397.796 524.614 396.74 525.905 396.782C527.36 396.829 529.281 398.092 530.087 399.64Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.367 396.768C553.075 398.207 552.337 399.919 550.895 400.228C549.415 400.546 547.645 399.405 546.993 397.814C546.41 396.388 546.93 395.113 548.252 394.773C549.744 394.387 551.627 395.26 552.367 396.768Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.933 388.7C573.452 387.988 575.314 388.511 575.961 389.9C576.588 391.247 575.759 393.145 574.281 393.766C572.95 394.327 571.353 393.759 570.65 392.528C569.852 391.131 570.42 389.411 571.933 388.7Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.909 379.074C599.422 380.392 598.52 382.274 596.98 383.095C595.445 383.915 593.739 383.381 593.279 381.997C592.874 380.776 593.625 379.225 595.012 378.406C596.546 377.503 598.41 377.797 598.909 379.074Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.505 368.585C617.189 369.772 615.625 369.776 614.988 368.636C614.423 367.624 614.858 366.096 616.028 364.989C617.336 363.751 618.998 363.507 619.699 364.486C620.36 365.409 619.765 367.447 618.505 368.585Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.715 397.881C505.414 399.417 504.252 400.516 502.187 400.239C500.127 399.963 497.813 398.363 497.213 396.814C496.684 395.447 497.715 394.532 499.557 394.702C501.593 394.89 504.037 396.392 504.715 397.881Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.571 394.988C475.498 396.468 474 397.675 471.476 397.455C468.893 397.231 466.012 395.676 465.237 394.103C464.544 392.697 465.753 391.759 468.057 391.894C470.658 392.046 473.603 393.44 474.571 394.988Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.039 391.601C438.84 393.074 437.176 394.219 434.611 393.941C431.985 393.657 429.199 392.069 428.566 390.506C427.999 389.109 429.326 388.22 431.673 388.408C434.322 388.62 437.199 390.06 438.039 391.601Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.529 388.311C391.524 387.948 388.474 386.289 387.977 384.764C387.53 383.392 389.215 382.568 391.923 382.829C394.956 383.119 398.141 384.636 398.879 386.15C399.592 387.617 397.486 388.668 394.529 388.311Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.52 381.465C354.926 382.944 352.614 383.829 349.572 383.353C346.519 382.876 343.699 381.171 343.467 379.678C343.263 378.36 345.229 377.618 347.974 377.97C351.018 378.363 354.121 380.012 354.52 381.465Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.089 372.344C305.167 372.68 308.219 374.233 308.739 375.737C309.241 377.196 306.894 378.194 303.902 377.791C301.206 377.43 298.531 376.025 297.861 374.632C297.099 373.05 299.023 372.009 302.089 372.344Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.06 371.537C253.97 371.236 251.129 369.7 250.683 368.105C250.288 366.691 252.004 365.806 254.751 366.012C257.823 366.242 260.934 367.697 261.627 369.237C262.28 370.691 260.021 371.826 257.06 371.537Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.015 364.679C214.136 366.158 211.546 367.03 208.488 366.55C205.419 366.067 202.849 364.364 202.907 362.873C202.959 361.558 205.137 360.815 207.915 361.171C210.993 361.566 213.895 363.228 214.015 364.679Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.26 359.048C168.28 360.536 165.614 361.423 162.552 360.958C159.484 360.494 157.002 358.802 157.153 357.306C157.287 355.984 159.528 355.223 162.318 355.564C165.402 355.94 168.24 357.596 168.26 359.048Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.019 351.354C121.118 351.704 123.892 353.348 123.805 354.804C123.715 356.314 120.977 357.212 117.882 356.767C115.12 356.37 112.927 355.015 112.711 353.591C112.47 352.002 114.834 350.994 118.019 351.354Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3746 352.646C73.6637 352.382 71.428 350.811 71.5136 349.257C71.5907 347.856 73.4453 346.937 75.9144 347.101C78.6822 347.284 81.1591 348.73 81.3107 350.274C81.4552 351.756 79.0365 352.904 76.3746 352.646Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7426 346.853C42.621 348.381 40.6102 349.433 38.4591 349.13C36.3049 348.827 34.6918 347.242 34.9259 345.698C35.133 344.333 36.7908 343.418 38.7661 343.607C40.9495 343.818 42.8602 345.364 42.7426 346.853Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84563 340.784C8.06366 340.81 10.0158 342.146 10.0615 343.699C10.106 345.196 8.09458 346.488 5.96931 346.376C4.05683 346.276 2.41897 345.081 2.23593 343.678C2.02687 342.085 3.64741 340.755 5.84563 340.784Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99864 323.982C4.48159 324.021 3.06075 322.804 2.89151 321.339C2.71723 319.819 3.73165 318.532 5.25577 318.394C6.94717 318.24 8.65675 319.634 8.75199 321.266C8.83207 322.65 7.50151 323.942 5.99864 323.982Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4386 325.127C41.3753 326.554 39.5754 327.627 37.5616 327.467C35.25 327.284 33.4006 325.65 33.6122 324.009C33.802 322.546 35.5697 321.633 37.6766 321.943C39.7273 322.246 41.501 323.734 41.4386 325.127Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5645 331.646C71.9012 331.392 69.7734 330.056 69.5662 328.527C69.359 327.006 71.1364 325.959 73.7401 326.094C76.5936 326.241 79.4097 327.932 79.3548 329.484C79.3058 330.896 77.0878 331.886 74.5645 331.646Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.499 332.102C120.848 333.472 118.886 334.6 116.408 334.473C113.921 334.343 111.323 332.954 110.835 331.501C110.259 329.786 112.222 328.606 115.141 328.939C117.663 329.228 120.138 330.683 120.499 332.102Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.539 340.013C155.894 339.666 153.634 338.261 153.273 336.752C152.913 335.246 154.569 334.284 157.149 334.517C159.975 334.77 162.914 336.536 163.026 338.061C163.127 339.447 161.052 340.345 158.539 340.013Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.576 338.803C205.484 339.224 208.292 340.742 208.735 342.145C209.22 343.692 206.428 344.695 203.278 344.115C200.351 343.576 197.879 342.01 197.689 340.59C197.495 339.135 199.576 338.368 202.576 338.803Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.836 347.291C256.095 348.649 253.873 349.479 251.058 349.083C247.781 348.621 244.859 346.841 244.747 345.26C244.649 343.884 246.944 343.222 249.899 343.78C252.797 344.329 255.584 345.97 255.836 347.291Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.468 356.792C293.503 356.391 290.747 354.958 290.023 353.453C289.299 351.95 290.894 351.048 293.764 351.337C296.896 351.652 300.455 353.45 300.909 354.957C301.321 356.326 299.274 357.171 296.468 356.792Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.37 359.118C343.853 360.494 342.182 361.364 339.744 360.999C336.913 360.579 334.085 358.805 333.691 357.221C333.344 355.823 335.116 355.135 337.716 355.657C340.248 356.166 342.901 357.783 343.37 359.118Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.124 361.219C383.637 361.662 386.359 363.198 387.071 364.581C387.873 366.142 385.898 367.106 383.129 366.497C380.571 365.935 378.095 364.348 377.558 362.944C377.005 361.491 378.525 360.759 381.124 361.219Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.249 369.464C427.034 370.862 425.7 371.816 423.349 371.53C420.648 371.201 417.553 369.451 416.822 367.852C416.17 366.425 417.65 365.662 420.188 366.107C422.657 366.539 425.483 368.101 426.249 369.464Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.144 377.174C457.381 377.06 454.938 375.688 453.87 374.219C452.763 372.696 453.245 371.551 454.967 371.583C456.878 371.617 459.654 373.144 460.731 374.761C461.643 376.128 460.889 377.287 459.144 377.174Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.761 377.661C493.662 379.082 492.95 380.146 491.2 379.962C489.171 379.746 486.549 378.084 485.615 376.434C484.792 374.978 485.675 374.115 487.602 374.458C489.477 374.791 491.888 376.285 492.761 377.661Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.965 382.08C513.795 382.019 511.969 380.718 510.946 379.251C509.886 377.733 509.864 376.484 510.993 376.482C512.248 376.48 514.448 377.924 515.502 379.536C516.395 380.903 516.122 382.141 514.965 382.08Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.39 382.017C537.178 382.352 535.334 381.359 534.367 379.917C533.363 378.421 533.47 376.991 534.646 376.589C535.953 376.141 538.127 377.156 539.111 378.752C539.946 380.103 539.587 381.687 538.39 382.017Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.633 373.057C563.473 374.28 563.137 376.109 561.948 376.847C560.768 377.582 558.863 377.056 557.908 375.783C556.771 374.267 557.063 372.46 558.571 371.807C559.887 371.236 561.765 371.788 562.633 373.057Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.844 362.081C587.665 363.162 587.302 365.065 586.097 366.034C584.888 367.007 583.008 366.86 582.061 365.755C580.947 364.45 581.281 362.564 582.812 361.596C584.135 360.758 585.994 360.963 586.844 362.081Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.589 348.01C609.199 349.134 608.732 350.98 607.585 351.962C606.251 353.104 604.519 352.851 603.855 351.463C603.277 350.257 603.841 348.575 605.12 347.666C606.375 346.773 607.997 346.918 608.589 348.01Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7505 333.363C25.8027 334.902 24.2145 335.964 22.0537 335.878C19.9867 335.796 18.1193 334.533 17.9234 333.11C17.7059 331.521 19.7195 330.089 21.9409 330.305C23.9555 330.5 25.7006 331.889 25.7505 333.363Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3957 337.743C60.48 339.267 58.5156 340.244 55.7975 340.06C53.1807 339.885 50.8659 338.564 50.6136 337.121C50.3358 335.528 52.848 334.211 55.6243 334.53C58.1378 334.818 60.3153 336.274 60.3957 337.743Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.273 340.848C100.238 342.3 98.1123 343.15 95.4302 342.808C92.7297 342.462 90.5816 341.075 90.4725 339.624C90.3528 338.041 92.9559 336.917 95.6962 337.394C98.1666 337.822 100.307 339.429 100.273 340.848Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.726 346.531C144.761 347.97 142.418 348.775 139.376 348.385C136.313 347.991 133.819 346.573 133.625 345.129C133.412 343.556 136.295 342.493 139.403 343.019C142.207 343.493 144.693 345.123 144.726 346.531Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.628 352.602C180.678 352.262 177.902 350.812 177.469 349.394C176.985 347.809 179.643 346.708 182.791 347.201C185.631 347.646 188.219 349.199 188.498 350.642C188.785 352.117 186.692 352.954 183.628 352.602Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.924 356.418C235.13 357.843 232.939 358.599 229.908 358.154C226.855 357.707 224.23 356.254 223.864 354.821C223.465 353.257 226.175 352.269 229.288 352.85C232.11 353.377 234.723 355.024 234.924 356.418Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.455 365.189C274.532 364.825 271.621 363.353 271.008 361.94C270.323 360.359 272.777 359.295 275.912 359.815C278.741 360.285 281.463 361.849 281.932 363.285C282.411 364.754 280.492 365.568 277.455 365.189Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.711 367.615C328.123 369.04 326.121 369.799 323.115 369.354C320.086 368.906 317.316 367.449 316.747 366.014C316.126 364.451 318.615 363.468 321.718 364.05C324.533 364.577 327.306 366.221 327.711 367.615Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.127 373.182C372.659 374.612 370.77 375.392 367.785 374.967C364.779 374.539 361.931 373.092 361.244 371.652C360.493 370.084 362.848 369.078 365.941 369.64C368.744 370.152 371.604 371.782 372.127 373.182Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.956 379.953C408.51 379.739 405.654 378.372 404.629 376.932C403.484 375.322 405.03 374.097 407.749 374.441C410.179 374.749 412.866 376.19 413.755 377.672C414.66 379.179 413.448 380.171 410.956 379.953Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.974 383.28C451.936 384.798 450.803 385.769 448.301 385.55C445.902 385.339 442.976 383.953 441.917 382.531C440.733 380.94 442.251 379.685 444.905 380.041C447.302 380.363 450.052 381.826 450.974 383.28Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.929 385.971C485.832 387.5 485.074 388.521 483.126 388.366C481.261 388.216 478.87 386.88 477.897 385.448C476.815 383.856 477.854 382.528 479.923 382.822C481.806 383.09 484.065 384.507 484.929 385.971Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.183 347.755C624.901 348.763 624.53 350.417 623.308 351.628C622.137 352.788 620.506 353.022 619.741 352.173C618.887 351.224 619.379 349.091 620.717 347.928C621.924 346.876 623.495 346.79 624.183 347.755Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.707 364.296C605.321 365.493 604.662 367.186 603.202 368.145C601.723 369.115 600.065 368.954 599.351 367.816C598.58 366.584 599.37 364.505 600.94 363.63C602.366 362.834 604.106 363.123 604.707 364.296Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.37 377.833C583.113 379.154 582.6 380.787 581.182 381.637C579.824 382.451 578.032 382.109 577.233 380.932C576.342 379.622 576.98 377.544 578.511 376.798C579.904 376.12 581.658 376.566 582.37 377.833Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.936 384.969C559.568 386.418 558.912 387.888 557.459 388.283C555.998 388.679 554.331 387.838 553.609 386.417C552.822 384.864 553.569 383.088 555.132 382.818C556.541 382.576 558.319 383.549 558.936 384.969Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.236 386.281C532.576 386.275 534.388 387.443 535.204 388.915C536.049 390.439 535.636 391.733 534.288 391.869C532.779 392.024 530.804 390.616 530.049 388.962C529.38 387.496 529.909 386.286 531.236 386.281Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.179 388.178C511.849 389.655 511.266 390.655 509.823 390.458C508.357 390.257 506.663 388.961 505.906 387.47C505.092 385.859 505.837 384.598 507.377 384.939C508.776 385.247 510.522 386.731 511.179 388.178Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.388 369.813C520.381 370.807 520.028 371.621 518.635 371.58C517.296 371.54 515.342 370.597 514.484 369.63C513.74 368.791 514.026 368.101 515.135 368.082C516.459 368.061 518.406 368.829 519.388 369.813Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.545 367.133C544.563 368.08 544.241 369.116 542.849 369.413C541.518 369.698 539.545 369.071 538.669 368.13C537.928 367.333 538.217 366.39 539.298 366.103C540.621 365.75 542.535 366.195 543.545 367.133Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.721 363.025C565.275 363.445 563.416 362.982 562.714 362.065C562.098 361.258 562.57 360.346 563.822 359.92C565.274 359.427 567.148 359.72 567.956 360.605C568.766 361.494 568.208 362.594 566.721 363.025Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.261 347.858C592.278 348.979 591.971 350.83 590.581 351.949C589.251 353.021 587.262 352.893 586.387 351.72C585.645 350.729 585.945 349.009 587.028 348.036C588.352 346.848 590.253 346.747 591.261 347.858Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.898 333.512C609.067 332.251 610.789 332 611.641 332.994C612.494 333.989 612.192 335.867 610.973 337.047C609.857 338.124 608.477 338.282 607.562 337.468C606.556 336.574 606.71 334.795 607.898 333.512Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.237 366.005C492.652 366.17 494.524 367.111 495.356 368.079C496.2 369.062 495.704 369.667 494.217 369.431C493.011 369.24 491.204 368.334 490.395 367.516C489.45 366.562 489.861 365.845 491.237 366.005Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.127 368.76C465.26 368.571 462.646 367.041 461.559 365.508C460.662 364.243 461.197 363.12 462.652 363.184C464.465 363.264 466.974 364.61 468.24 366.184C469.538 367.798 469.048 368.957 467.127 368.76Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.314 359.782C432.395 360.219 434.722 361.842 435.421 363.354C436.123 364.874 434.963 365.656 432.795 365.105C431.077 364.668 428.81 363.083 428.081 361.816C427.221 360.321 428.288 359.358 430.314 359.782Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.815 358.446C399.598 359.973 398.044 360.758 395.309 360.203C392.687 359.674 389.813 357.875 389.301 356.454C388.839 355.18 390.224 354.508 392.51 354.886C395.17 355.328 398.045 356.947 398.815 358.446Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.844 349.286C355.535 349.74 358.332 351.366 358.993 352.865C359.665 354.394 358.005 355.162 355.236 354.595C352.912 354.119 350.392 352.653 349.59 351.314C348.695 349.824 350.265 348.851 352.844 349.286Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.371 346.235C317.298 347.814 315.851 348.784 313.141 348.398C310.549 348.03 307.619 346.354 306.966 344.871C306.413 343.615 307.824 342.696 309.963 342.915C312.581 343.183 315.455 344.671 316.371 346.235Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.976 337.352C268.637 337.706 271.456 339.302 272.077 340.817C272.698 342.333 270.897 343.227 268.179 342.755C265.692 342.323 263.46 341.049 262.65 339.603C261.76 338.017 263.269 336.996 265.976 337.352Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.332 333.74C226.911 335.296 225.101 336.211 222.324 335.774C219.653 335.351 216.976 333.646 216.664 332.179C216.392 330.904 218.048 330.065 220.314 330.333C223.018 330.653 225.759 332.202 226.332 333.74Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.175 331.494C174.471 330.951 172.097 329.155 172.184 327.74C172.264 326.471 174.129 325.802 176.53 326.193C179.326 326.645 181.823 328.284 181.979 329.779C182.139 331.301 179.996 332.062 177.175 331.494Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.486 324.023C139.665 325.558 137.496 326.425 134.689 325.954C131.96 325.497 129.644 323.8 129.692 322.309C129.734 320.989 131.566 320.239 134.013 320.554C136.797 320.913 139.308 322.498 139.486 324.023Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0335 321.15C91.3193 320.923 88.7542 319.388 88.5215 317.865C88.3293 316.607 90.1923 315.499 92.3829 315.587C95.1134 315.696 97.7649 317.083 98.2375 318.66C98.7226 320.275 96.8288 321.386 94.0335 321.15Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4347 315.508C58.351 317.076 56.4605 317.994 54.2118 317.584C52.0558 317.191 50.3555 315.488 50.6196 314.014C50.8582 312.694 52.4807 311.876 54.4144 312.127C56.6658 312.419 58.5164 313.965 58.4347 315.508Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7858 311.567C23.8806 313.167 22.5464 314.332 20.8612 314.167C19.24 314.007 17.8555 312.492 17.9087 310.962C17.9541 309.633 19.1365 308.546 20.5326 308.583C22.1983 308.625 23.693 309.988 23.7858 311.567Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.21 361.072C494.958 360.955 493.003 360.014 491.914 359.022C490.951 358.146 490.931 357.514 491.97 357.588C493.108 357.67 495.203 358.629 496.355 359.645C497.373 360.544 497.298 361.173 496.21 361.072Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.486 363.176C520.146 363.259 518.005 362.368 517.125 361.411C516.349 360.565 516.63 359.77 517.741 359.689C519.017 359.596 521.173 360.421 522.12 361.409C522.923 362.247 522.611 363.109 521.486 363.176Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.752 357.924C547.709 358.725 547.607 359.743 546.539 360.175C545.321 360.668 543.216 360.241 542.167 359.323C541.108 358.396 541.395 357.275 542.779 356.966C543.996 356.694 545.781 357.11 546.752 357.924Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.454 345.891C569.934 345.412 571.832 345.781 572.617 346.735C573.283 347.547 572.751 348.574 571.446 348.981C570.088 349.404 568.413 349.136 567.56 348.389C566.57 347.521 566.986 346.368 568.454 345.891Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.614 332.994C592.069 331.982 593.977 332.25 594.805 333.628C595.509 334.801 595.032 336.514 593.746 337.382C592.411 338.284 590.72 338.151 589.833 337.113C588.804 335.907 589.17 334 590.614 332.994Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.972 319.942C612.858 321.321 611.07 321.589 610.113 320.548C609.267 319.626 609.317 318.042 610.244 316.814C611.258 315.469 613.1 315.166 614.112 316.2C615.005 317.116 614.94 318.743 613.972 319.942Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.534 358.238C470.008 357.986 468.031 356.937 467.287 355.989C466.644 355.172 467.138 354.63 468.342 354.819C469.783 355.044 471.706 356.063 472.567 357.063C473.266 357.877 472.775 358.444 471.534 358.238Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.879 354.613C443.961 356.052 443.521 357.029 441.852 356.863C439.962 356.671 437.245 355.083 436.145 353.531C435.009 351.927 435.805 350.938 437.842 351.392C439.632 351.792 441.799 353.175 442.879 354.613Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.759 351.179C405.607 350.695 403.077 348.923 402.437 347.46C401.882 346.191 402.917 345.404 404.645 345.773C406.703 346.214 409.167 347.937 409.944 349.489C410.581 350.762 409.531 351.579 407.759 351.179Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.598 346.341C366.971 346.06 363.784 344.451 362.752 342.889C361.842 341.511 362.807 340.622 365.007 340.805C367.418 341.002 370.635 342.631 371.802 344.247C372.834 345.678 371.883 346.586 369.598 346.341Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.508 338.859C332.201 340.174 330.812 341.041 328.542 340.711C325.893 340.328 322.692 338.546 322.02 337.092C321.424 335.797 322.805 334.946 325.022 335.24C327.525 335.57 330.711 337.344 331.508 338.859Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.003 334.334C281.105 333.742 278.375 331.971 278.104 330.518C277.869 329.266 279.655 328.571 281.954 329.02C284.707 329.555 287.401 331.297 287.843 332.841C288.203 334.094 286.355 334.812 284.003 334.334Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.074 329.535C239.268 329.231 236.31 327.613 235.706 326.06C235.173 324.687 236.536 323.813 238.904 324.01C241.5 324.227 244.503 325.874 245.236 327.488C245.885 328.916 244.515 329.801 242.074 329.535Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.838 317.721C197.064 317.943 199.879 319.408 200.682 320.764C201.62 322.35 199.951 323.549 197.259 323.232C194.93 322.958 192.106 321.501 191.372 320.2C190.5 318.65 192.169 317.453 194.838 317.721Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.005 312.228C154.839 312.756 157.194 314.487 157.146 316.029C157.106 317.338 154.977 318.012 152.464 317.522C149.853 317.01 147.667 315.588 147.376 314.223C147.04 312.639 149.192 311.704 152.005 312.228Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.206 311.982C109.85 311.495 107.972 309.788 108.128 308.298C108.262 307.011 109.995 306.206 111.874 306.57C114.124 307.006 116.002 308.699 115.963 310.279C115.931 311.562 114.118 312.378 112.206 311.982Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0855 307.109C76.1469 308.456 74.5015 309.459 72.5868 309.258C70.3531 309.025 68.2351 307.364 68.2429 305.87C68.2501 304.543 69.8491 303.54 71.7363 303.7C73.8661 303.881 76.0155 305.556 76.0855 307.109Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4669 305.732C34.7039 305.384 33.3991 303.763 33.6201 302.23C33.8112 300.908 35.1854 299.972 36.5982 300.225C38.2898 300.526 39.6138 302.144 39.4681 303.76C39.3503 305.072 37.899 306.017 36.4669 305.732Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09925 298.966C8.15462 300.434 7.0086 301.561 5.48174 301.582C3.75373 301.607 2.22229 300.207 2.21778 298.625C2.21327 296.993 3.65764 295.771 5.3563 296.013C6.84812 296.227 8.0427 297.503 8.09925 298.966Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.744 351.286C495.999 351.34 497.865 352.097 498.956 353.039C499.993 353.935 499.915 354.778 498.813 354.783C497.693 354.787 495.788 353.928 494.643 352.946C493.493 351.957 493.527 351.233 494.744 351.286Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.49 351.128C519.539 350.168 519.885 349.317 521.275 349.195C522.609 349.078 524.587 349.751 525.397 350.635C526.233 351.548 525.835 352.525 524.568 352.663C523.258 352.805 521.467 352.113 520.49 351.128Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.751 344.402C551.685 345.176 551.464 346.376 550.301 346.85C549.089 347.344 547.221 347.02 546.148 346.16C545.074 345.3 545.256 344.277 546.568 343.809C547.857 343.349 549.794 343.609 550.751 344.402Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.734 333.074C576.572 333.871 576.171 335.018 574.849 335.573C573.526 336.129 571.747 335.914 570.788 335.112C569.866 334.339 570.258 333.269 571.659 332.704C573.008 332.16 574.943 332.323 575.734 333.074Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.029 322.502C594.891 323.58 593.284 323.532 592.375 322.424C591.5 321.357 591.774 319.601 592.973 318.501C594.137 317.436 595.865 317.403 596.626 318.455C597.432 319.569 597.165 321.424 596.029 322.502Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.507 299.329C613.634 298.091 615.402 297.691 616.213 298.512C617.023 299.335 616.798 301.276 615.753 302.484C614.662 303.749 613.006 304.058 612.068 303.19C611.129 302.321 611.32 300.632 612.507 299.329Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.047 347.811C471.257 347.976 473.254 348.929 474.212 349.8C475.18 350.679 475.024 351.394 473.877 351.266C472.68 351.13 470.795 350.215 469.703 349.238C468.596 348.249 468.752 347.635 470.047 347.811Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.846 345.773C449.891 346.66 449.263 347.26 447.507 347.034C445.696 346.801 443.315 345.846 442.11 344.875C440.936 343.928 441.538 343.383 443.439 343.65C445.257 343.904 447.831 344.915 448.846 345.773Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.494 341.492C418.513 342.362 417.849 343.028 416.124 342.855C414.308 342.673 411.894 341.734 410.733 340.762C409.559 339.779 410.151 339.205 412.088 339.432C413.933 339.649 416.464 340.614 417.494 341.492Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.785 336.785C382.522 337.655 381.473 338.188 379.567 337.907C377.6 337.617 375.362 336.633 374.485 335.676C373.634 334.745 374.61 334.258 376.664 334.583C378.626 334.892 381.071 335.942 381.785 336.785Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.304 330.559C343.89 331.981 342.689 332.737 340.663 332.221C338.636 331.701 336.505 330.112 335.802 328.597C335.124 327.138 336.286 326.411 338.387 326.974C340.413 327.517 342.75 329.218 343.304 330.559Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.429 325.591C304.091 326.964 302.454 327.81 299.999 327.362C297.456 326.897 294.793 325.308 293.986 323.786C293.191 322.283 294.664 321.521 297.332 322.051C299.848 322.554 302.783 324.253 303.429 325.591Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.587 321.111C255.055 320.745 252.319 319.193 251.506 317.663C250.695 316.137 252.141 315.261 254.767 315.691C257.311 316.108 260.208 317.712 260.92 319.102C261.626 320.482 260.002 321.461 257.587 321.111Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.55 313.707C218.923 315.095 216.968 315.919 214.436 315.451C211.824 314.967 209.38 313.389 208.872 311.866C208.377 310.384 210.164 309.617 212.879 310.153C215.474 310.668 218.189 312.365 218.55 313.707Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.867 309.212C168.789 308.848 166.773 307.301 166.371 305.771C165.962 304.212 167.302 303.361 169.503 303.795C171.553 304.198 173.772 305.843 174.099 307.208C174.428 308.581 172.845 309.558 170.867 309.212Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.953 301.688C133.078 303.095 131.333 303.991 129.288 303.582C127.176 303.161 125.357 301.622 125.134 300.081C124.917 298.579 126.503 297.741 128.694 298.214C130.788 298.664 132.832 300.325 132.953 301.688Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4887 298.744C87.3897 298.47 85.4992 296.985 85.2645 295.434C85.0246 293.857 86.5032 292.914 88.7232 293.252C90.7929 293.566 92.8972 295.151 93.071 296.536C93.2469 297.93 91.4897 299.005 89.4887 298.744Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1666 292.967C55.2111 294.39 53.8265 295.484 52.3034 295.253C50.7221 295.013 49.382 293.558 49.2898 291.994C49.1963 290.421 50.3841 289.44 52.0557 289.736C53.6187 290.012 55.1235 291.569 55.1666 292.967Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6281 293.139C19.0372 292.868 17.8583 291.435 17.9088 289.857C17.9582 288.328 19.302 287.334 20.9555 287.636C22.5255 287.923 23.9011 289.498 23.7836 290.897C23.6561 292.389 22.2047 293.408 20.6281 293.139Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.507 341.704C476.593 342.678 476.284 343.143 474.816 342.734C473.575 342.39 472.017 341.564 471.059 340.753C469.98 339.836 469.997 339.179 471.2 339.441C472.415 339.707 474.443 340.751 475.507 341.704Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.903 344.516C502.037 345.527 501.857 346.38 500.519 346.383C499.398 346.386 497.686 345.711 496.679 344.898C495.487 343.936 495.455 343.012 496.626 342.894C497.747 342.78 499.818 343.548 500.903 344.516Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.909 339.431C525.279 339.2 527.195 339.823 528.058 340.817C528.796 341.665 528.472 342.525 527.31 342.799C525.983 343.109 523.959 342.524 523.059 341.604C522.149 340.673 522.549 339.659 523.909 339.431Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.577 334.122C552.275 334.736 550.304 334.54 549.304 333.731C548.328 332.941 548.605 331.729 549.874 331.224C550.952 330.794 552.702 330.952 553.702 331.589C554.948 332.379 554.891 333.505 553.577 334.122Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.119 318.966C574.218 318.254 576.331 318.176 577.389 318.831C578.377 319.443 578.384 320.396 577.4 321.117C576.265 321.951 574.318 322.128 573.143 321.526C571.962 320.92 571.952 319.724 573.119 318.966Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.271 302.037C597.379 302.952 597.362 304.748 596.238 306.048C595.297 307.136 593.795 307.497 592.826 306.885C591.69 306.17 591.531 304.325 592.494 302.933C593.421 301.597 595.209 301.162 596.271 302.037Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.146 285.408C616.013 286.825 614.26 287.308 613.343 286.474C612.447 285.66 612.648 283.698 613.756 282.444C614.699 281.378 616.258 280.964 617.168 281.551C618.3 282.28 618.288 283.981 617.146 285.408Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.777 337.146C452.975 338.165 452.892 338.84 451.576 338.65C450.477 338.489 448.752 337.703 447.708 336.884C446.483 335.921 446.411 335.127 447.537 335.185C448.625 335.24 450.623 336.165 451.777 337.146Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.625 334.404C425.067 335.423 424.719 336.064 422.827 335.838C421.243 335.648 418.977 334.848 417.7 334.028C416.204 333.067 416.359 332.3 418.011 332.39C419.599 332.478 422.246 333.427 423.625 334.404Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.335 330.24C387.376 330.021 384.803 329.034 383.768 328.104C382.758 327.195 383.567 326.582 385.417 326.844C386.989 327.067 389.246 327.951 390.366 328.784C391.757 329.819 391.311 330.46 389.335 330.24Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.99 324.659C355.174 325.684 354.477 326.285 352.404 326.019C350.663 325.794 348.48 324.987 347.396 324.164C346.15 323.219 346.69 322.473 348.518 322.595C350.288 322.713 352.865 323.686 353.99 324.659Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.597 318.136C315.083 319.036 313.619 319.348 311.295 318.836C309.353 318.409 307.456 317.464 306.977 316.692C306.412 315.783 307.727 315.334 309.812 315.722C311.905 316.11 314.102 317.216 314.597 318.136Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.143 310.704C276.038 311.715 275.019 312.296 272.848 312.008C271.032 311.77 268.916 310.937 268.049 310.122C267.036 309.168 267.904 308.454 269.892 308.601C271.805 308.744 274.286 309.737 275.143 310.704Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.085 303.714C229 303.89 231.505 304.972 232.138 305.897C232.729 306.761 231.866 307.286 230.053 307.167C227.956 307.028 225.526 306.115 224.737 305.167C223.942 304.213 225.049 303.528 227.085 303.714Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.195 297.45C189.28 297.732 191.405 298.807 191.746 299.759C192.046 300.599 190.884 301.04 188.937 300.831C186.728 300.593 184.443 299.59 184.017 298.674C183.599 297.775 185.151 297.175 187.195 297.45Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.83 289.728C147.817 289.999 150.131 291.706 150.538 293.207C150.911 294.584 149.803 295.442 147.908 295.259C145.696 295.042 143.405 293.601 142.878 292.092C142.347 290.569 143.746 289.443 145.83 289.728Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.708 288.33C110.963 289.911 109.294 290.75 106.962 290.229C104.957 289.783 103.261 288.492 102.941 287.18C102.577 285.684 104.186 284.538 106.266 284.828C108.29 285.11 110.462 286.819 110.708 288.33Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.601 284.758C67.9144 284.589 66.3645 283.623 66.2848 282.695C66.205 281.775 67.5981 281.108 69.1715 281.324C70.5208 281.51 71.8543 282.36 72.1112 283.201C72.4283 284.241 71.3098 284.926 69.601 284.758Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5035 280.785C37.3413 281.744 35.8116 282.22 34.0787 281.866C32.6303 281.569 31.5658 280.7 31.6383 279.885C31.7216 278.926 33.1754 278.296 34.7915 278.532C36.412 278.772 37.669 279.806 37.5035 280.785Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4405 277.495C7.54849 278.514 6.38463 279.264 4.8732 279.177C3.60573 279.102 2.44187 278.391 2.24916 277.581C2.01971 276.62 3.07557 275.73 4.52909 275.685C5.92018 275.642 7.33689 276.518 7.4405 277.495Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.261 334.243C478.451 335.199 478.387 336.021 477.148 335.863C476.078 335.728 474.291 334.861 473.19 333.975C471.893 332.93 471.915 332.217 473.253 332.416C474.35 332.578 476.255 333.434 477.261 334.243Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.652 335.881C502.252 335.92 500.264 335.004 499.411 333.968C498.663 333.059 499.062 332.397 500.348 332.383C501.563 332.372 503.45 333.054 504.313 333.845C505.348 334.796 505.01 335.843 503.652 335.881Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.915 326.924C528.232 326.524 530.428 327.001 531.298 327.908C532.047 328.692 531.768 329.776 530.721 330.13C529.443 330.561 527.359 330.029 526.362 329.048C525.489 328.191 525.727 327.285 526.915 326.924Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.233 321.538C555.156 322.075 553.355 321.97 552.265 321.327C550.972 320.564 551.032 319.374 552.391 318.741C553.509 318.221 555.37 318.271 556.378 318.868C557.552 319.563 557.481 320.914 556.233 321.538Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.532 304.106C578.491 304.773 578.275 306.134 577.089 306.783C576.069 307.34 574.448 307.31 573.579 306.732C572.671 306.128 572.682 305.118 573.597 304.414C574.672 303.588 576.56 303.43 577.532 304.106Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.741 286.003C595.893 284.685 597.847 284.364 598.646 285.381C599.333 286.258 599.124 288.118 598.213 289.209C597.099 290.546 595.239 290.775 594.322 289.712C593.52 288.784 593.702 287.192 594.741 286.003Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.279 267.414C614.452 266.538 614.594 264.948 615.612 263.718C616.736 262.359 618.704 261.947 619.53 262.906C620.24 263.727 620.07 265.594 619.186 266.709C618.114 268.062 616.211 268.401 615.279 267.414Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.847 332.361C450.859 332.22 449.047 331.364 447.871 330.484C446.477 329.439 446.355 328.713 447.591 328.917C448.608 329.085 450.456 329.948 451.558 330.767C452.841 331.723 452.996 332.526 451.847 332.361Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.229 326.165C428.229 327.104 427.821 327.728 426.416 327.389C425.201 327.097 423.412 326.136 422.52 325.3C421.587 324.425 421.719 323.859 422.814 324.005C424.095 324.176 426.217 325.214 427.229 326.165Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.252 320.504C393.072 320.673 395.846 321.696 397.117 322.667C398.149 323.454 397.798 324.066 396.354 323.973C394.725 323.868 391.81 322.778 390.541 321.8C389.414 320.932 389.731 320.363 391.252 320.504Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.979 316.458C364.994 317.388 363.951 317.946 361.912 317.56C360.152 317.226 357.893 316.243 356.988 315.418C356.041 314.555 356.6 314.034 358.261 314.222C360.194 314.442 362.957 315.522 363.979 316.458Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.978 310.685C327.082 311.635 326.188 312.297 324.174 312.017C322.436 311.775 320.161 310.854 319.156 309.986C317.972 308.963 318.793 308.347 320.909 308.667C322.644 308.928 325.046 309.885 325.978 310.685Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.513 303.683C288.504 304.631 287.446 305.296 285.385 305.018C283.608 304.778 281.386 303.857 280.482 302.989C279.414 301.961 280.375 301.348 282.547 301.667C284.329 301.928 286.673 302.881 287.513 303.683Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.132 295.353C244.232 295.637 246.822 296.802 247.285 297.677C247.681 298.428 246.419 298.944 244.704 298.734C242.628 298.481 240.16 297.339 239.626 296.387C239.15 295.542 240.229 295.097 242.132 295.353Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.101 289.75C205.236 290.022 207.746 291.182 208.095 292.061C208.394 292.814 207.008 293.341 205.266 293.141C203.156 292.897 200.773 291.763 200.358 290.808C199.991 289.961 201.169 289.504 203.101 289.75Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.129 285.414C166.815 286.371 165.344 287.076 163.177 286.835C161.302 286.627 159.27 285.74 158.649 284.861C158.028 283.982 158.939 283.333 160.723 283.386C162.777 283.446 165.433 284.443 166.129 285.414Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.314 280.489C126.866 281.448 125.241 282.168 123.058 281.94C121.177 281.744 119.21 280.859 118.709 279.985C118.119 278.955 119.589 278.278 121.868 278.538C123.735 278.753 125.848 279.679 126.314 280.489Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.84 275.005C88.0139 275.95 86.498 276.61 84.8735 276.309C83.4752 276.05 82.1495 275.11 81.9887 274.271C81.8213 273.395 82.8084 272.786 84.2368 272.895C85.9227 273.023 87.6629 274.04 87.84 275.005Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6252 269.385C51.3405 269.437 53.0349 270.378 53.1964 271.377C53.3271 272.182 52.2086 272.881 50.8005 272.883C49.2179 272.883 47.4934 271.89 47.3366 270.891C47.198 270.005 48.1975 269.342 49.6252 269.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3467 266.582C20.0729 266.577 21.7269 267.476 21.8258 268.482C21.9053 269.292 20.7289 270.032 19.3106 270.08C17.7176 270.133 16.0464 269.185 15.9512 268.18C15.8657 267.29 16.9113 266.585 18.3467 266.582Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.012 322.926C453.006 323.812 452.76 324.225 451.462 323.835C450.202 323.456 448.333 322.398 447.356 321.53C446.381 320.664 446.577 320.244 447.828 320.622C449.119 321.011 451.015 322.039 452.012 322.926Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.431 325.833C480.45 326.805 480.244 327.533 478.962 327.479C477.766 327.43 475.755 326.501 474.8 325.591C473.835 324.671 474.049 323.926 475.261 323.986C476.505 324.047 478.438 324.887 479.431 325.833Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.506 326.057C504.174 326.226 502.233 325.526 501.417 324.615C500.592 323.696 501.023 322.784 502.347 322.611C503.686 322.436 505.585 323.074 506.43 324.014C507.289 324.971 506.885 325.884 505.506 326.057Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.317 318.903C530.986 319.335 529.041 318.949 528.22 318.12C527.393 317.281 527.824 316.211 529.145 315.775C530.481 315.335 532.377 315.674 533.225 316.53C534.089 317.403 533.693 318.457 532.317 318.903Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.546 304.143C557.509 304.798 557.424 305.944 556.349 306.648C555.296 307.337 553.578 307.361 552.612 306.722C551.693 306.115 551.803 304.895 552.826 304.235C553.9 303.542 555.585 303.492 556.546 304.143Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.016 291.928C577.884 292.626 576.133 292.67 575.332 292.034C574.522 291.393 574.798 290.254 575.922 289.552C577.06 288.843 578.769 288.785 579.597 289.44C580.442 290.109 580.188 291.207 579.016 291.928Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.132 271.49C599.076 272.792 597.355 273.27 596.402 272.543C595.488 271.844 595.604 269.959 596.637 268.694C597.721 267.366 599.406 266.884 600.36 267.644C601.313 268.404 601.211 270.159 600.132 271.49Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.366 245.465C617.476 244.174 619.182 243.787 620.052 244.634C620.956 245.512 620.773 247.168 619.62 248.509C618.539 249.766 616.756 250.175 615.92 249.364C615.069 248.539 615.278 246.73 616.366 245.465Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.745 319.916C428.794 320.86 428.633 321.377 427.354 321.113C426.142 320.865 424.144 319.826 423.176 318.94C422.195 318.043 422.395 317.491 423.594 317.743C424.817 318 426.727 319 427.745 319.916Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.247 314.158C401.327 315.116 401.2 315.735 399.948 315.549C398.731 315.366 396.836 314.437 395.769 313.498C394.748 312.599 394.914 311.934 396.098 312.111C397.304 312.292 399.192 313.224 400.247 314.158Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.955 308.902C370.667 309.799 370.072 310.217 368.594 309.85C367.141 309.488 365.295 308.417 364.63 307.549C363.972 306.691 364.619 306.253 366.016 306.604C367.447 306.961 369.248 308.012 369.955 308.902Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.328 304.027C336.128 304.918 335.165 305.319 333.132 304.939C331.129 304.562 328.743 303.485 328.001 302.624C327.268 301.77 328.305 301.349 330.229 301.714C332.199 302.086 334.533 303.143 335.328 304.027Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.623 297.526C299.555 298.447 298.702 298.984 296.739 298.709C294.815 298.441 292.403 297.441 291.484 296.533C290.612 295.67 291.56 295.083 293.398 295.343C295.321 295.617 297.695 296.608 298.623 297.526Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.216 292.349C256.151 291.988 253.888 290.917 253.36 290.053C252.835 289.197 254.111 288.753 256.099 289.102C258.15 289.463 260.359 290.513 260.939 291.405C261.522 292.301 260.325 292.716 258.216 292.349Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.657 283.512C222.355 284.435 221.23 284.981 219.18 284.717C217.171 284.456 214.885 283.464 214.196 282.554C213.542 281.69 214.776 281.09 216.694 281.341C218.704 281.604 220.96 282.591 221.657 283.512Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.93 278.055C182.296 278.964 180.892 279.408 178.735 279.071C176.64 278.742 174.506 277.678 174.187 276.807C173.867 275.938 175.352 275.463 177.398 275.784C179.511 276.118 181.563 277.143 181.93 278.055Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.087 272.762C138.51 272.424 136.998 271.348 136.889 270.49C136.778 269.625 138.008 269.161 139.56 269.488C141.128 269.82 142.619 270.883 142.754 271.773C142.891 272.678 141.715 273.111 140.087 272.762Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.133 266.544C104.471 267.494 103.429 268.129 101.836 267.956C100.283 267.784 98.7141 266.868 98.369 265.931C98.0447 265.048 99.177 264.344 100.674 264.508C102.234 264.678 103.795 265.597 104.133 266.544Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2026 260.872C68.4726 261.828 67.3626 262.5 65.7597 262.366C64.1947 262.234 62.6761 261.348 62.3957 260.406C62.1336 259.518 63.3351 258.771 64.8432 258.897C66.416 259.027 67.9326 259.917 68.2026 260.872Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.832 257.938C37.0717 258.915 35.9529 259.64 34.3317 259.579C32.754 259.517 31.2611 258.689 31.0117 257.739C30.772 256.831 31.9658 256.033 33.5072 256.084C35.0739 256.138 36.5995 256.986 36.832 257.938Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79606 254.689C6.20343 254.771 7.43998 255.662 7.44737 256.612C7.45606 257.591 6.3309 258.261 4.85424 258.177C3.48401 258.1 2.21529 257.181 2.21778 256.279C2.22026 255.363 3.42707 254.61 4.79606 254.689Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.875 317.707C452.983 318.625 452.849 319.331 451.534 318.998C450.29 318.685 448.968 318.087 447.732 317.126C446.498 316.167 446.401 315.47 447.513 315.597C448.531 315.712 450.752 316.774 451.875 317.707Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.708 317.199C481.772 318.131 481.563 319.139 480.22 319.079C478.944 319.021 477.612 318.603 476.414 317.656C475.219 316.712 475.199 315.761 476.351 315.6C477.412 315.451 479.626 316.25 480.708 317.199Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.802 313.139C509.875 314.006 509.687 315.244 508.343 315.489C507.074 315.72 505.74 315.543 504.535 314.693C503.333 313.845 503.304 312.715 504.454 312.248C505.511 311.819 507.711 312.259 508.802 313.139Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.165 304.515C536.035 305.352 535.677 306.561 534.409 307.016C533.401 307.376 531.73 307.13 531.003 306.528C530.086 305.771 530.265 304.489 531.352 303.968C532.475 303.429 534.298 303.679 535.165 304.515Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.844 292.876C553.731 292.293 553.642 291.118 554.64 290.312C555.551 289.578 557.512 289.461 558.521 290.098C559.285 290.581 559.408 291.793 558.746 292.401C557.87 293.204 555.909 293.435 554.844 292.876Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.325 274.13C578.29 274.957 576.343 275.245 575.454 274.714C574.545 274.172 574.699 272.875 575.845 272.178C576.989 271.478 578.172 271.29 579.222 271.688C580.35 272.115 580.386 273.279 579.325 274.13Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.817 250.338C602.706 251.284 602.382 253.263 601.135 254.446C600.141 255.389 598.459 255.679 597.716 255.044C596.779 254.239 596.918 252.184 597.989 250.961C599.095 249.694 600.926 249.391 601.817 250.338Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.935 228.001C618.946 229.35 616.996 229.912 616.063 229.117C615.11 228.307 615.173 226.233 616.28 225.078C617.388 223.923 618.575 223.579 619.667 224.161C620.834 224.785 620.949 226.618 619.935 228.001Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.752 313.482C426.073 313.059 424.217 312.054 423.21 311.158C422.217 310.274 422.371 309.744 423.507 310.089C424.694 310.449 426.829 311.651 427.495 312.425C427.957 312.963 427.71 313.228 427.752 313.482Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.851 307.974C403.958 308.89 403.821 309.541 402.492 309.181C401.229 308.839 399.889 308.239 398.668 307.288C397.453 306.341 397.392 305.649 398.503 305.803C399.526 305.944 401.727 307.045 402.851 307.974Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.485 303.247C375.158 303.364 374.923 303.78 374.074 303.663C372.825 303.491 370.725 302.23 369.942 301.309C369.17 300.401 369.769 299.916 371.137 300.337C372.567 300.776 374.497 301.987 375.485 303.247Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.2 295.632C341.946 296.529 341.202 296.951 339.66 296.503C338.431 296.149 336.613 295.115 335.98 294.418C335.176 293.528 335.736 292.953 337.086 293.273C338.483 293.603 340.451 294.73 341.2 295.632Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.846 292.093C306.408 292.195 305.957 292.59 305.006 292.455C303.603 292.254 301.658 290.977 301.118 290.066C300.583 289.165 301.487 288.711 302.928 289.154C304.433 289.619 306.208 290.845 306.846 292.093Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.996 283.569C270.681 284.473 269.849 285.06 268.313 284.65C266.854 284.263 265.541 283.636 264.726 282.694C263.916 281.756 264.487 281.117 265.915 281.322C267.232 281.511 269.302 282.65 269.996 283.569Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.786 277.236C233.398 278.149 232.476 278.754 230.915 278.36C229.442 277.988 228.143 277.373 227.4 276.427C226.658 275.484 227.318 274.828 228.791 275.014C230.144 275.186 232.166 276.31 232.786 277.236Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.539 270.783C191.113 270.255 189.462 269.218 189.21 268.342C188.961 267.483 190.239 267.028 191.777 267.433C193.384 267.856 195.24 269.107 195.048 269.842C194.915 270.353 193.938 270.556 193.539 270.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.463 263.382C156.713 264.289 155.404 264.746 153.768 264.328C152.459 263.995 150.936 262.987 150.669 262.28C150.33 261.386 151.504 260.767 153.001 261.056C154.55 261.354 156.21 262.468 156.463 263.382Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.519 258.245C118.868 259.167 117.608 259.834 116.019 259.491C114.516 259.166 113.302 258.583 112.819 257.631C112.337 256.681 113.302 255.969 114.872 256.097C116.311 256.215 118.166 257.307 118.519 258.245Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1248 252.06C77.7469 251.111 78.7961 250.385 80.4043 250.493C81.8705 250.59 83.6493 251.651 83.9075 252.58C84.1029 253.284 83.0446 254.02 81.8967 253.981C80.3716 253.93 78.4863 252.97 78.1248 252.06Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2352 247.715C48.6341 247.915 49.9363 248.967 49.9389 249.907C49.9415 250.693 48.9577 251.259 47.745 251.175C46.3311 251.078 44.8034 250.066 44.7138 249.17C44.621 248.254 45.882 247.521 47.2352 247.715Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0119 245.939C13.8008 244.985 14.8498 244.173 16.3029 244.184C17.6261 244.194 19.1075 245.176 19.2104 246.117C19.289 246.83 18.2143 247.651 17.173 247.682C15.7906 247.723 14.214 246.851 14.0119 245.939Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8741 223.617C18.0978 224.655 17.1583 225.348 15.6467 225.278C14.1664 225.211 12.843 224.402 12.6934 223.477C12.5377 222.518 13.5247 221.779 14.9755 221.783C16.3003 221.786 17.6666 222.649 17.8741 223.617Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6164 227.217C46.9033 228.246 46.0149 228.894 44.5121 228.767C43.0301 228.642 41.6776 227.796 41.4704 226.867C41.2578 225.912 42.198 225.218 43.6289 225.288C44.9566 225.352 46.347 226.249 46.6164 227.217Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6226 232.207C78.9743 233.225 78.1382 233.832 76.6464 233.652C75.1736 233.475 73.7852 232.593 73.5211 231.67C73.2498 230.723 74.1388 230.077 75.5502 230.198C76.8674 230.314 78.2885 231.242 78.6226 232.207Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.261 237.852C111.701 238.873 110.955 239.452 109.482 239.24C108.042 239.03 106.583 238.118 106.241 237.213C105.886 236.272 106.687 235.658 108.084 235.805C109.358 235.938 110.852 236.9 111.261 237.852Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.268 244.827C142.842 244.589 141.354 243.67 140.932 242.761C140.495 241.827 141.214 241.239 142.581 241.414C143.833 241.572 145.367 242.549 145.856 243.496C146.381 244.511 145.714 245.068 144.268 244.827Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.292 247.684C180.224 247.978 181.836 248.953 182.414 249.889C183.022 250.871 182.377 251.385 180.878 251.11C179.401 250.839 177.508 249.804 177.418 249.052C177.339 248.396 178.055 248.013 178.292 247.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.723 254.684C216.616 255.001 218.281 255.984 218.948 256.913C219.649 257.892 219.091 258.391 217.617 258.102C216.164 257.817 214.219 256.77 214.043 256.025C213.889 255.377 214.534 255.008 214.723 254.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.299 263.407C254.971 264.317 254.242 264.731 252.666 264.328C251.021 263.909 249.401 262.947 248.836 262.053C248.299 261.204 249.079 260.755 250.498 261.099C251.931 261.445 253.597 262.457 254.299 263.407Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.566 269.723C288.325 270.626 287.696 271.032 286.164 270.626C284.562 270.199 282.899 269.23 282.24 268.341C281.614 267.496 282.286 267.054 283.66 267.403C285.055 267.758 286.773 268.779 287.566 269.723Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.443 277.399C322.32 278.311 321.841 278.73 320.363 278.333C318.823 277.919 317.117 276.957 316.338 276.063C315.596 275.209 316.114 274.756 317.438 275.096C318.773 275.438 320.527 276.448 321.443 277.399Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.258 284.71C348.978 284.436 347.129 283.492 346.118 282.591C345.08 281.665 345.204 281.117 346.39 281.329C347.478 281.525 349.379 282.518 350.475 283.458C351.645 284.463 351.561 284.986 350.258 284.71Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.49 289.003C379.638 290.013 379.721 290.57 378.672 290.325C377.644 290.086 375.982 289.151 374.988 288.25C373.959 287.315 373.907 286.735 374.853 286.916C375.718 287.082 377.422 288.062 378.49 289.003Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.129 294.103C403.202 295.028 403.216 295.511 402.146 295.174C401.027 294.824 399.459 293.891 398.436 292.966C397.474 292.098 397.471 291.574 398.416 291.86C399.379 292.151 401.017 293.142 402.129 294.103Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.222 297.579C425.132 298.14 426.669 298.957 427.708 299.74C428.954 300.681 428.491 301.131 427.138 300.744C425.73 300.342 423.997 299.344 423.047 298.422C422.149 297.55 422.435 297.097 424.222 297.579Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.62 301.993C457.612 302.571 457.296 303.022 455.916 302.98C454.474 302.936 452.731 302.459 451.808 301.875C450.929 301.32 451.262 300.859 452.508 300.884C453.774 300.908 455.584 301.389 456.62 301.993Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.306 298.781C483.106 298.985 484.462 299.203 485.359 299.585C486.436 300.044 485.971 300.682 484.742 300.838C483.461 301 481.924 300.695 481.122 300.136C480.364 299.609 480.684 299.013 482.306 298.781Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.375 289.684C511.177 289.883 512.533 289.995 513.443 290.496C514.536 291.1 514.106 292.34 512.891 292.876C511.621 293.436 510.085 293.211 509.256 292.372C508.475 291.581 508.769 290.437 510.375 289.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.07 276.031C539.169 276.645 539.198 277.678 538.123 278.476C537.063 279.263 535.413 279.412 534.436 278.83C533.431 278.233 533.434 277.159 534.428 276.358C535.35 275.615 537.034 275.456 538.07 276.031Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.46 258.278C558.261 258.275 559.618 258.041 560.522 258.321C561.605 258.655 561.164 260.018 559.943 260.872C558.672 261.764 557.126 261.94 556.311 261.304C555.54 260.701 555.85 259.455 557.46 258.278Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.134 237.13C579.616 235.906 581.408 235.535 582.499 235.941C583.653 236.372 583.653 237.334 582.489 238.228C581.339 239.111 579.308 239.623 578.652 239.024C578.081 238.503 578.242 237.609 578.134 237.13Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.893 212.845C602.404 212.814 603.258 212.541 603.848 212.783C604.557 213.073 604.342 214.411 603.604 215.293C602.837 216.212 601.864 216.452 601.314 215.86C600.794 215.299 600.927 214.055 601.893 212.845Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.211 185.169C620.826 185.989 620.747 187.699 620.027 188.991C619.276 190.343 618.299 190.681 617.719 189.782C617.169 188.928 617.255 187.08 617.902 185.852C618.554 184.613 619.568 184.317 620.211 185.169Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48591 234.645C4.86966 234.936 4.05639 235.609 3.00313 235.759C1.49948 235.971 0.124798 234.777 0.266979 233.637C0.381051 232.718 1.56322 232.135 2.97496 232.316C4.32303 232.489 5.51703 233.393 5.48591 234.645Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0627 239.283C30.0513 239.258 28.7659 238.524 28.4393 237.569C28.1153 236.622 28.9061 235.819 30.2087 235.784C31.7863 235.742 33.7752 236.764 33.5835 237.707C33.442 238.398 32.4608 238.901 32.0627 239.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6662 241.162C63.1046 241.404 62.3967 242.012 61.3847 242.079C59.9407 242.175 58.4391 240.885 58.4365 239.767C58.4339 238.866 59.5223 238.379 60.9226 238.666C62.2614 238.94 63.5354 239.923 63.6662 241.162Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8214 242.199C96.3862 242.647 97.623 243.347 98.1309 244.093C98.8343 245.123 97.3883 245.838 95.7887 245.498C94.4917 245.223 93.2967 244.245 93.1091 243.312C92.9189 242.362 93.7949 241.837 95.8214 242.199Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.789 249.448C133.361 250.656 132.428 251.282 131.011 251.171C129.255 251.03 127.442 249.958 127.12 248.866C126.852 247.96 127.855 247.373 129.443 247.859C130.711 248.246 131.937 249.032 132.789 249.448Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.004 258.184C167.787 257.785 166.288 256.882 165.787 255.949C165.3 255.046 166.101 254.501 167.577 254.74C169.416 255.035 171.672 256.292 171.521 257.078C171.408 257.661 170.396 257.925 170.004 258.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.828 263.796C206.348 263.982 205.85 264.505 204.842 264.482C203.407 264.449 201.407 263.065 201.008 261.984C200.685 261.111 201.627 260.743 203.152 261.145C204.61 261.528 206.25 262.589 206.828 263.796Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.303 270.783C240.143 270.349 238.524 269.43 237.827 268.503C237.152 267.605 237.766 267.089 239.196 267.352C240.977 267.68 243.379 268.958 243.435 269.728C243.475 270.297 242.602 270.538 242.303 270.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.044 277.241C279.474 277.786 279.331 278.345 278.614 278.472C277.824 278.612 275.773 277.539 274.859 276.631C273.705 275.485 273.994 274.616 275.631 275.141C276.778 275.511 278.147 276.326 280.044 277.241Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.365 284.783C311.604 283.723 310.145 282.981 309.305 282.297C308.257 281.444 308.976 281.082 310.4 281.394C312.046 281.755 314.551 283.034 314.681 283.676C314.784 284.172 313.983 284.325 313.365 284.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.683 289.77C348.385 289.935 348.227 290.428 347.4 290.379C346.257 290.314 343.899 288.863 343.065 287.817C342.399 286.979 343.034 286.637 344.438 287.072C345.813 287.498 347.652 288.585 348.683 289.77Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.819 293.351C374.637 293.813 376.165 294.545 377.203 295.291C378.642 296.32 378.243 296.963 376.759 296.564C375.555 296.242 373.786 295.233 372.81 294.314C371.819 293.378 372.011 292.91 373.819 293.351Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.504 300.279C404.424 301.113 404.504 301.699 403.669 301.562C402.66 301.399 400.741 300.271 399.627 299.184C398.71 298.289 398.844 297.863 399.928 298.193C400.979 298.513 402.594 299.456 403.504 300.279Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.631 205.553C619.368 205.409 620.723 204.772 621.683 205.057C623.009 205.45 622.799 207.992 621.548 209.471C620.534 210.671 618.942 210.944 617.995 210.079C617.03 209.198 617.095 207.537 618.631 205.553Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.199 228.084C604.519 229.01 604.56 230.745 603.716 232.045C602.669 233.656 600.786 234.177 599.682 233.167C598.767 232.331 598.811 230.575 600.076 229.544C601.086 228.72 602.401 228.439 603.199 228.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.283 257.04C579.695 258.188 578.08 258.419 576.973 257.967C575.919 257.538 575.904 256.533 576.937 255.743C578.226 254.758 580.592 254.299 581.179 255.076C581.614 255.651 581.278 256.556 581.283 257.04Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.176 275.624C559.02 276.165 559.09 277.073 558.477 277.763C557.626 278.722 555.382 278.686 554.38 277.869C553.583 277.22 553.919 276.114 555.099 275.466C556.255 274.828 558.007 274.763 559.176 275.624Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.759 289.684C534.491 289.737 535.848 289.583 536.779 289.955C538.067 290.467 537.759 292.114 536.469 292.831C535.422 293.413 533.84 293.256 532.94 292.495C532.027 291.722 532.166 290.674 533.759 289.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.924 301.582C508.726 301.69 510.091 301.631 511.123 302.05C512.465 302.594 512.382 304.195 511.211 304.801C510.19 305.33 508.696 305.091 507.631 304.253C506.612 303.446 506.553 302.391 507.924 301.582Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.912 309.765C484.325 310.505 484.273 311.133 483.266 311.32C482.019 311.552 479.906 311.119 478.736 310.412C477.766 309.826 477.906 309.24 479.365 309.286C480.53 309.323 482.004 309.64 482.912 309.765Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.447 312.082C452.845 311.956 451.243 311.144 450.146 310.166C449.099 309.232 449.088 308.525 450.125 308.586C451.418 308.661 453.798 309.723 454.372 310.623C454.798 311.289 454.449 311.736 454.447 312.082Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.753 306.102C427.687 306.589 427.972 307.104 427.52 307.179C427.025 307.262 424.718 306.115 423.378 305.203C421.772 304.107 421.272 303.285 422.896 303.887C424.035 304.312 425.66 305.157 427.753 306.102Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.979 287.968C400.75 288.052 400.721 288.432 399.989 288.219C399.189 287.984 397 286.404 396.188 285.55C395.553 284.849 395.529 284.542 396.645 285C397.791 285.467 399.641 286.663 400.979 287.968Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.94 293.875C427.851 293.796 426.101 293.206 425.139 292.597C424.322 292.079 424.285 291.789 425.142 291.783C426.046 291.778 427.965 292.339 428.981 292.905C430.013 293.479 429.993 293.952 428.94 293.875Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.159 293.829C457.538 294.04 455.677 293.615 454.632 292.989C453.737 292.452 453.69 292.056 454.531 291.846C455.4 291.629 457.822 292.001 458.507 292.538C459.12 293.018 459.011 293.496 459.159 293.829Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.733 286.978C484.899 286.727 486.714 286.991 487.504 287.539C488.296 288.085 487.928 288.848 486.692 288.954C485.495 289.057 484.321 288.885 483.399 288.409C482.338 287.86 482.491 287.243 483.733 286.978Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.218 279.184C512.373 278.977 510.922 278.872 510.063 278.335C509.195 277.794 509.332 276.867 510.401 276.188C511.518 275.481 513.241 275.517 514.161 276.296C515.1 277.091 514.916 278.353 513.218 279.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.912 261.679C538.71 262.256 538.729 263.238 538.016 263.953C537.224 264.748 534.936 264.605 534.164 263.83C533.499 263.164 533.434 262.404 534.536 261.629C535.672 260.83 537.513 260.693 538.912 261.679Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.445 241.888C562.211 242.471 562.169 243.429 561.423 244.192C560.593 245.038 558.343 245.102 557.63 244.41C557.018 243.814 557.001 243.073 558.138 242.215C559.306 241.332 561.127 241.042 562.445 241.888Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.802 219.616C582.098 220.428 580.965 220.649 580.434 220.017C579.983 219.483 579.943 218.768 580.551 217.898C581.202 216.966 582.295 216.606 582.922 217.114C583.554 217.626 583.501 218.809 582.802 219.616Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.705 191.693C602.441 190.858 603.545 190.742 604.035 191.445C604.516 192.137 604.273 193.736 603.482 194.169C602.859 194.507 602.002 194.591 601.498 194.335C600.729 193.944 600.931 192.571 601.705 191.693Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.624 166.342C620.522 166.918 620.577 167.875 620.156 168.628C619.688 169.464 618.229 169.489 617.706 168.776C617.255 168.161 617.179 167.404 617.842 166.561C618.525 165.697 619.69 165.459 620.624 166.342Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.325 282.615C379.499 283.567 379.77 284.251 378.879 284.045C377.946 283.831 376.209 282.825 375.062 281.818C374.094 280.969 373.903 280.527 374.576 280.588C375.282 280.65 377.177 281.689 378.325 282.615Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.383 277.061C353.47 278.006 353.562 278.665 352.563 278.437C351.518 278.197 349.779 277.179 348.743 276.182C347.866 275.337 347.784 274.911 348.568 274.992C349.392 275.08 351.32 276.137 352.383 277.061Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.713 267.321C321.812 267.532 323.565 268.531 324.531 269.488C325.484 270.433 325.32 271.019 324.146 270.692C322.984 270.368 321.823 269.645 320.836 268.802C319.636 267.777 319.636 267.114 320.713 267.321Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.004 264.417C292.781 264.136 291.055 263.079 290.27 262.111C289.601 261.286 289.718 260.881 290.702 261.004C291.741 261.135 293.65 262.208 294.535 263.132C295.437 264.073 295.186 264.69 294.004 264.417Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.494 258.118C259.209 257.836 257.515 256.78 256.831 255.811C256.25 254.987 256.449 254.581 257.502 254.706C258.615 254.836 260.509 255.91 261.311 256.837C262.127 257.777 261.737 258.391 260.494 258.118Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.427 247.8C226.782 248.137 228.471 249.257 228.931 250.125C229.392 250.993 228.508 251.483 227.16 250.983C225.855 250.501 224.761 249.794 224.135 248.928C223.417 247.932 223.985 247.443 225.427 247.8Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.88 240.753C193.483 241.702 192.799 242.297 191.437 242.009C190.053 241.716 188.422 240.63 188.004 239.685C187.651 238.885 187.982 238.457 189.217 238.614C190.558 238.786 192.271 239.796 192.88 240.753Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.38 233.845C156.822 234.247 158.278 235.375 158.441 236.221C158.602 237.052 157.256 237.528 155.991 236.883C154.998 236.376 153.887 235.502 153.434 234.848C152.74 233.849 153.863 233.424 155.38 233.845Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.769 230.2C125.198 230.387 124.505 230.928 123.43 230.88C122.235 230.825 120.571 229.344 120.54 228.441C120.513 227.664 121.011 227.198 122.415 227.453C123.861 227.716 125.384 228.793 125.769 230.2Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4012 225.131C88.8149 224.543 87.6245 223.687 87.28 222.902C86.9328 222.11 87.75 221.632 89.1875 221.827C90.6871 222.031 92.1677 223.026 92.3991 223.99C92.6338 224.974 91.5225 225.584 89.4012 225.131Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1213 216.888C58.6079 216.962 60.1029 217.871 60.3605 218.859C60.6167 219.832 59.5427 220.552 58.0967 220.348C56.6651 220.145 55.7858 219.471 55.3335 218.629C54.785 217.605 55.6629 216.814 57.1213 216.888Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0827 213.449C29.0093 213.708 29.7658 214.764 29.6647 215.668C29.5655 216.556 28.4813 217.235 27.7462 216.685C27.1687 216.254 26.6018 215.439 26.4442 214.781C26.205 213.779 27.1064 213.176 28.0827 213.449Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5197 212.35C3.59899 213.333 2.83815 214.151 1.92544 214.08C0.999465 214.01 0.204492 213.074 0.259534 212.065C0.305816 211.208 0.717586 210.648 1.58957 210.587C2.5343 210.523 3.43936 211.36 3.5197 212.35Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.941 284.082C401.077 283.094 399.681 282.433 398.647 281.758C397.226 280.828 397.498 280.298 398.96 280.741C400.266 281.137 401.827 281.918 402.592 282.659C403.161 283.21 402.828 283.478 402.941 284.082Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.95 286.881C431.094 286.404 429.693 286.119 428.673 285.744C427.271 285.229 427.607 284.705 429.092 284.79C430.42 284.867 431.974 285.23 432.706 285.718C433.252 286.08 432.884 286.379 432.95 286.881Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.428 284.14C462.35 284.478 462.576 285.019 462.069 285.325C461.403 285.726 458.511 285.302 457.73 284.741C456.94 284.17 456.98 283.683 458.192 283.467C459.379 283.253 460.648 283.436 462.428 284.14Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.187 276.871C491.126 277.191 491.362 277.746 490.86 278.138C490.199 278.654 487.296 278.562 486.499 278.052C485.696 277.535 485.752 277.013 486.941 276.614C487.996 276.26 489.67 276.287 491.187 276.871Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.626 263.553C516.594 264.086 516.882 264.964 516.416 265.682C515.804 266.626 512.891 266.895 512.053 266.171C511.206 265.439 511.215 264.571 512.367 263.743C513.39 263.007 515.059 262.81 516.626 263.553Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.754 246.806C537.565 246.576 538.982 246.156 539.918 246.32C541.261 246.558 541.03 247.587 540.186 248.528C539.309 249.51 536.431 250.192 535.877 249.504C535.426 248.945 535.767 248.012 535.754 246.806Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.152 222.422C562.291 222.133 563.175 221.677 563.773 221.806C564.634 221.99 564.517 222.995 564.013 223.938C563.488 224.921 561.687 225.693 561.315 225.044C561.012 224.515 561.2 223.595 561.152 222.422Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.017 199.43C582.866 199.73 582.009 200.158 581.362 200.073C580.467 199.955 580.593 198.431 581.472 197.475C582.257 196.618 583.211 196.296 583.707 196.88C584.078 197.315 583.908 198.292 584.017 199.43Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.282 171.385C604.114 172.504 604.206 173.284 603.85 173.922C603.306 174.897 601.854 175.187 601.327 174.534C600.824 173.911 600.911 173.032 601.702 172.4C602.296 171.927 603.146 171.808 604.282 171.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.494 147.808C620.517 148.4 620.76 149.205 620.519 149.929C620.204 150.883 618.404 151.44 617.824 150.827C617.236 150.207 617.161 149.351 617.834 148.458C618.494 147.584 619.285 147.362 620.494 147.808Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.994 276.455C377.111 276.617 377.641 277.004 377.369 277.076C377.013 277.168 374.179 276.246 373.147 275.712C372.105 275.171 371.872 274.883 372.786 275.014C373.6 275.129 375.214 275.658 376.994 276.455Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.259 269.524C353.038 269.785 353.218 270.106 352.66 270.081C351.809 270.041 349.449 269.162 348.569 268.588C347.729 268.039 347.841 267.807 349.1 268.13C350.044 268.372 351.422 268.904 353.259 269.524Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.721 263.532C327.683 263.779 327.957 264.396 327.474 264.479C326.839 264.589 323.926 262.999 323.109 262.126C322.282 261.244 322.305 260.794 323.46 261.061C324.487 261.295 326.156 262.209 327.721 263.532Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.757 258.184C297.886 257.085 296.472 256.372 295.574 255.689C294.469 254.846 295.353 254.367 296.838 254.922C298.198 255.429 299.769 256.234 300.216 256.985C300.52 257.496 299.999 257.683 299.757 258.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.115 251.184C267.328 250.196 265.943 249.552 265.027 248.884C263.76 247.962 264.402 247.399 265.969 247.832C267.371 248.22 268.872 249.013 269.431 249.756C269.847 250.309 269.305 250.573 269.115 251.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.553 244.043C236.841 244.434 236.6 244.945 235.861 244.876C234.733 244.774 232.793 243.292 232.43 242.348C232.083 241.447 232.589 241.09 233.856 241.653C234.809 242.076 235.927 242.98 237.553 244.043Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.867 234.791C204.566 235.081 204.425 235.694 203.711 235.778C202.77 235.889 200.173 234.303 199.784 233.432C199.391 232.549 199.769 232.081 201.116 232.367C202.436 232.646 203.565 233.356 204.867 234.791Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.528 227.87C170.648 228.294 170.262 228.826 169.467 228.78C168.259 228.709 166.496 227.249 166.323 226.29C166.16 225.376 166.797 224.991 168.051 225.53C168.992 225.934 170 226.825 171.528 227.87Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.47 218.984C134.908 220.026 136.258 220.739 136.685 221.363C137.253 222.192 136.55 222.629 135.114 222.441C133.541 222.234 131.515 221.028 131.659 220.282C131.76 219.752 132.66 219.527 133.47 218.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.85 215.803C103.842 216.3 103.34 216.883 102.509 216.883C101.241 216.884 99.6318 215.471 99.6207 214.486C99.6103 213.547 100.345 213.095 101.579 213.579C102.504 213.942 103.415 214.806 104.85 215.803Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4726 210.811C73.0582 211.111 72.6163 211.794 71.7475 211.962C70.6055 212.182 68.3084 210.73 68.2469 209.82C68.1855 208.899 68.8333 208.365 70.2669 208.507C71.5403 208.635 72.8823 209.47 73.4726 210.811Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5079 208.485C40.6608 207.605 39.9232 207.071 39.5969 206.433C39.1469 205.554 40.0636 204.779 41.1018 205.034C42.0302 205.264 42.7768 205.961 42.7474 206.752C42.7251 207.339 42.0806 207.736 41.5079 208.485Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9464 204.242C14.7651 204.891 14.1076 205.567 13.2341 205.67C11.9026 205.828 10.5367 204.536 10.7363 203.493C10.9269 202.498 11.7976 201.934 12.9879 202.291C13.881 202.56 14.6511 203.363 15.9464 204.242Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.178 269.689C373.889 269.876 374.098 270.18 373.443 270.055C372.571 269.888 370.985 269.274 369.819 268.654C368.634 268.026 368.683 267.817 369.814 268.124C370.646 268.351 372.173 268.973 374.178 269.689Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.209 276.285C405.863 276.665 406.02 277.094 405.346 277.082C404.449 277.065 402.885 276.541 401.774 275.881C400.646 275.212 400.748 274.858 401.892 275.022C402.733 275.146 404.229 275.706 406.209 276.285Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.455 278.483C433.486 277.966 431.927 277.664 431.078 277.293C429.888 276.776 430.369 276.409 431.652 276.384C432.966 276.359 434.704 276.704 435.389 277.228C435.875 277.599 435.464 277.932 435.455 278.483Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.35 273.144C465.986 273.901 466.121 274.533 465.439 274.799C464.531 275.156 462.972 274.979 461.882 274.384C460.778 273.78 460.906 273.157 462.057 272.934C462.903 272.771 464.387 273.04 466.35 273.144Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.152 262.383C492.912 263.16 493.145 263.747 492.511 264.106C491.64 264.599 490.004 264.593 488.846 264.174C487.67 263.749 487.58 263.121 488.79 262.745C489.648 262.479 491.173 262.54 493.152 262.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.993 247.684C517.826 248.923 517.965 249.835 517.556 250.435C517.013 251.235 516.012 251.426 515.276 250.851C514.528 250.265 514.558 249.284 515.265 248.611C515.785 248.118 516.745 248.09 517.993 247.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.526 227.383C541.271 228.576 541.335 229.444 540.89 230.037C540.312 230.806 539.333 231.154 538.677 230.638C538.034 230.133 538.156 229.196 538.869 228.497C539.401 227.976 540.323 227.866 541.526 227.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.714 202.184C565.594 203.304 565.766 204.072 565.379 204.699C564.849 205.561 563.813 205.894 563.062 205.551C562.299 205.202 562.217 204.34 562.966 203.568C563.498 203.019 564.466 202.79 565.714 202.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.876 176.283C584.118 176.364 585.064 176.157 585.566 176.527C586.246 177.031 586.062 178.133 585.18 179C584.331 179.834 583.266 180.11 582.843 179.292C582.545 178.721 582.833 177.691 582.876 176.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.282 151.084C603.988 152.364 604.024 153.299 603.578 153.869C602.978 154.638 601.999 154.858 601.396 154.174C600.836 153.538 600.867 152.549 601.645 151.887C602.207 151.407 603.091 151.414 604.282 151.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.356 127.984C618.578 128.047 619.434 127.896 620.089 128.187C620.781 128.496 620.796 130.162 620.169 130.729C619.424 131.402 618.422 131.897 617.851 130.992C617.463 130.375 617.553 129.341 617.356 127.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.258 264.143C352.85 264.301 352.939 264.583 352.248 264.447C351.282 264.256 349.694 263.624 348.714 263.031C347.801 262.479 347.708 262.174 349.003 262.547C349.915 262.811 351.342 263.419 353.258 264.143Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.725 259.582C327.743 258.476 326.216 257.728 325.317 257.087C324.053 256.189 324.353 255.89 325.5 256.202C326.675 256.522 328.378 257.386 329.2 258.158C329.783 258.705 329.539 258.967 329.725 259.582Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.189 247.684C300.111 248.878 301.612 249.676 302.361 250.298C303.377 251.142 302.974 251.425 301.503 250.963C300.089 250.52 298.407 249.645 297.835 248.907C297.437 248.391 297.988 248.227 298.189 247.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.161 243.858C273.7 244.343 273.74 244.973 273.022 244.872C272.067 244.735 270.546 243.806 269.564 242.732C268.567 241.641 268.786 241.131 269.95 241.504C270.804 241.777 272.229 242.762 274.161 243.858Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.744 236.327C244.061 236.729 243.906 237.333 243.112 237.15C242.095 236.912 240.604 235.971 239.86 234.892C239.144 233.85 239.586 233.426 240.748 233.841C241.63 234.154 242.95 235.194 244.744 236.327Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.785 228.783C210.005 227.671 208.517 226.921 207.868 226.281C206.957 225.383 207.765 225.089 209.185 225.408C210.638 225.734 212.286 226.604 212.654 227.374C212.916 227.92 212.222 228.174 211.785 228.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.334 221.816C180.292 222.13 179.829 222.648 178.982 222.434C177.841 222.141 176.551 221.144 176.196 220.106C175.868 219.143 176.424 218.666 177.71 219.218C178.646 219.618 179.713 220.633 181.334 221.816Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.956 215.043C149.085 215.58 148.747 216.248 147.921 216.179C146.821 216.088 145.51 215.189 144.948 214.105C144.377 213.002 144.953 212.448 146.167 212.778C147.059 213.017 148.225 213.984 149.956 215.043Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.924 207.27C116.97 207.842 116.555 208.53 115.713 208.482C114.587 208.419 113.326 207.539 112.855 206.449C112.374 205.343 113.019 204.763 114.239 205.063C115.135 205.285 116.242 206.237 117.924 207.27Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8441 199.383C83.6396 200.527 84.3888 201.269 84.5463 201.894C84.7588 202.742 84.0763 203.105 83.0435 202.743C82.0505 202.395 81.2033 201.591 81.3288 200.816C81.4164 200.276 82.1204 200.027 82.8441 199.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8707 195.184C54.7205 196.191 55.4337 196.811 55.7514 197.462C56.0874 198.149 55.1552 198.887 54.3799 198.632C53.4569 198.33 52.4652 197.743 52.56 196.891C52.6234 196.311 53.2608 195.934 53.8707 195.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0591 193.496C26.1719 193.968 25.6523 194.578 25.0871 194.472C24.2973 194.325 23.7192 193.364 23.7977 192.316C23.8712 191.339 24.4225 190.671 25.2282 191.135C25.7984 191.461 26.2484 192.419 27.0591 193.496Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52585 190.175C2.71434 190.877 2.23779 191.685 1.68149 191.683C0.96888 191.682 0.267583 190.936 0.25745 189.798C0.247318 188.7 0.849775 188.033 1.5882 188.213C2.14791 188.347 2.66381 189.268 3.52585 190.175Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.595177 165.785C-0.165038 167.056 0.231437 167.786 0.25739 168.475C0.268895 168.808 -0.43005 169.369 -0.778541 169.275C-1.12703 169.18 -1.74727 168.252 -1.70118 167.941C-1.60417 167.286 -1.15102 166.795 -0.595177 165.785Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9281 169.984C24.8102 171.189 25.5844 171.904 25.747 172.597C25.8276 172.939 24.7944 173.557 24.2202 173.477C23.6302 173.396 22.4561 172.481 22.4834 172.166C22.5424 171.496 23.2115 170.978 23.9281 169.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5922 175.442C49.8725 175.861 49.5692 176.229 49.0926 176.278C48.2886 176.359 47.2524 175.636 47.3276 175.051C47.3786 174.659 47.8571 174.125 48.2219 174.189C48.8259 174.297 49.4953 174.836 50.5922 175.442Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9601 178.383C77.9688 179.311 78.7441 179.837 79.1572 180.44C79.7292 181.268 78.9807 182.17 78.0002 181.795C77.3229 181.538 76.1234 180.678 76.0933 180.373C76.0273 179.701 76.5503 179.21 76.9601 178.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.119 187.117C107.864 187.207 107.527 187.498 106.97 187.482C106.088 187.459 104.754 186.572 104.856 186.085C104.931 185.731 105.368 185.426 105.889 185.385C106.596 185.331 107.838 186.227 108.119 187.117Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.815 190.283C135.926 191.252 136.748 191.813 137.239 192.426C137.916 193.267 137.352 194.094 136.355 193.667C135.668 193.371 134.384 192.459 134.307 192.161C134.135 191.503 134.556 191.06 134.815 190.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.38 202.183C164.462 201.242 163.709 200.606 163.256 199.957C162.681 199.134 163.293 198.45 164.117 198.76C164.97 199.082 166.329 200.486 166.299 201.131C166.276 201.596 165.793 201.75 165.38 202.183Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.724 204.984C194.997 206.427 195.956 207.311 196.34 208.008C196.528 208.348 195.77 208.633 195.199 208.398C194.63 208.167 193.229 206.989 193.143 206.697C192.962 206.08 193.4 205.77 193.724 204.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.093 215.196C226.922 215.267 226.781 215.526 226.305 215.477C225.552 215.397 223.998 214.454 223.851 213.99C223.744 213.654 223.968 213.388 224.386 213.383C224.955 213.376 226.426 214.319 227.093 215.196Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.627 221.084C251.854 222.087 252.697 222.676 253.313 223.294C254.16 224.146 254.066 224.911 253.14 224.44C252.501 224.116 251.16 223.16 250.982 222.868C250.591 222.221 250.738 221.819 250.627 221.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.775 229.482C278.267 230.786 279.24 231.521 279.847 232.192C280.161 232.541 280.087 233.08 279.711 232.967C279.312 232.849 277.958 231.904 277.718 231.59C277.221 230.942 277.187 230.472 276.775 229.482Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.924 235.783C304.081 236.78 304.847 237.363 305.462 237.98C306.308 238.828 306.469 239.607 305.678 239.146C305.132 238.828 303.903 237.878 303.692 237.585C303.228 236.937 303.215 236.526 302.924 235.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.496 242.082C325.929 242.879 326.912 243.376 327.556 243.798C327.872 244.005 327.822 244.263 327.449 244.158C327.067 244.049 325.692 243.391 325.456 243.21C324.951 242.823 324.902 242.59 324.496 242.082Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.683 252.464C348.482 252.487 348.416 252.667 347.74 252.533C346.67 252.323 344.059 251.258 343.614 250.865C343.292 250.58 343.464 250.423 344.043 250.503C344.829 250.616 347.333 251.644 348.683 252.464Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.951 260.283C379.706 259.594 377.981 259.137 377.029 258.725C376.504 258.496 376.928 258.21 377.554 258.185C378.399 258.15 381.212 258.935 381.803 259.376C382.214 259.682 381.912 259.865 381.951 260.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.031 261.684C410.489 262.401 411.531 262.791 412.034 263.199C412.28 263.398 411.708 263.806 411.163 263.783C410.621 263.76 409.118 263.255 408.967 263.065C408.651 262.666 408.944 262.338 409.031 261.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.471 258.408C442.951 259.222 442.95 259.761 442.342 260.044C441.323 260.524 439.041 260.239 438.476 259.582C438.098 259.143 438.166 258.352 438.754 258.246C439.726 258.068 441.273 258.318 443.471 258.408Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.965 249.783C470.465 250.109 471.544 250.185 472.134 250.527C472.424 250.695 472.038 251.528 471.535 251.737C471.019 251.949 469.473 251.919 469.281 251.721C468.877 251.297 469.059 250.696 468.965 249.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.805 233.684C495.298 233.848 496.364 233.802 496.963 234.094C497.258 234.237 496.923 235.167 496.439 235.448C495.943 235.735 494.418 235.889 494.22 235.7C493.799 235.3 493.946 234.64 493.805 233.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.195 213.383C524.88 214.457 524.463 215.908 523.41 216.548C522.796 216.921 521.877 217.002 521.494 216.69C520.898 216.204 521.531 214.424 522.443 213.878C523.101 213.485 523.802 213.485 524.195 213.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.178 191.43C547.151 191.531 546.337 191.817 545.837 191.611C545.114 191.313 545.474 189.767 546.313 188.929C547.199 188.044 548.521 187.88 548.697 188.802C548.81 189.389 548.426 190.277 548.178 191.43Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.871 164.845C566.825 164.938 566.006 165.218 565.488 165.008C564.737 164.702 565.042 163.15 565.867 162.315C566.737 161.436 568.082 161.287 568.297 162.213C568.436 162.803 568.078 163.688 567.871 164.845Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.931 136.385C587.877 137.506 588.058 138.126 587.775 138.695C587.322 139.61 585.731 140.213 585.115 139.692C584.71 139.351 584.501 138.386 584.842 138.026C585.402 137.437 586.484 137.113 587.931 136.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.667 111.885C602.583 112.226 603.214 112.205 603.566 112.707C603.738 112.949 603.528 114.424 603.239 114.877C602.95 115.327 602.057 115.552 601.938 115.24C601.685 114.585 601.766 113.514 601.667 111.885Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.077 91.6589C620.962 92.5094 620.728 93.3914 619.712 93.6252C619.12 93.7624 618.165 93.6518 617.715 93.3697C617.015 92.9294 617.412 91.8339 618.295 91.6435C618.93 91.5063 619.676 91.6477 620.077 91.6589Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.726 76.1855C619.494 76.455 620.027 76.5173 620.37 76.7966C620.85 77.19 620.602 78.2582 620.031 78.2841C619.619 78.3037 619.012 78.0643 618.773 77.7493C618.558 77.4665 618.726 76.9205 618.726 76.1855Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.929 91.584C604.898 92.7383 605.011 93.5573 604.829 94.2181C604.576 95.1399 604.022 95.2785 603.525 94.8564C602.913 94.3377 602.767 92.9602 603.316 92.3414C603.695 91.9116 604.225 91.8857 604.929 91.584Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.087 114.684C586.845 114.759 587.375 114.562 587.707 114.91C588.172 115.4 587.886 117.656 587.313 118.039C586.899 118.314 586.3 118.192 586.071 117.715C585.868 117.287 586.057 116.127 586.087 114.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.481 140.705C569.23 140.688 569.757 140.426 570.079 140.73C570.529 141.156 570.204 143.431 569.629 143.877C569.217 144.198 568.626 144.15 568.409 143.703C568.216 143.306 568.426 142.14 568.481 140.705Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.371 167.883C549.135 168.969 549.172 169.712 548.776 170.392C548.215 171.358 546.547 171.753 546.178 170.957C545.97 170.51 546.21 169.427 546.677 168.965C547.194 168.453 548.198 168.325 549.371 167.883Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.957 193.239C526.16 193.202 527.024 192.923 527.517 193.218C528.208 193.628 527.525 195.908 526.572 196.365C525.885 196.695 524.939 196.656 524.624 196.219C524.342 195.827 524.764 194.667 524.957 193.239Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.304 216.883C502.118 217.992 502.193 218.701 501.844 219.352C501.344 220.284 500.471 220.541 499.746 220.295C498.837 219.986 498.774 218.808 499.708 218.08C500.339 217.588 501.157 217.402 502.304 216.883Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.502 235.783C475.367 236.509 475.483 236.998 475.155 237.389C474.685 237.947 473.792 237.994 473.025 237.721C472.065 237.381 471.937 236.576 472.867 236.219C473.496 235.978 474.337 235.97 475.502 235.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.891 245.582C447.085 245.938 447.946 246.062 448.431 246.364C449.111 246.786 448.397 247.742 447.447 247.679C446.762 247.634 445.826 247.317 445.52 246.997C445.245 246.708 445.679 246.251 445.891 245.582Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.668 253.215C416.437 253.814 416.477 254.319 416.097 254.549C415.567 254.872 414.71 254.579 414.024 254.031C413.181 253.356 413.176 252.55 414.106 252.585C414.748 252.61 415.556 252.938 416.668 253.215Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.291 253.777C384.995 254.178 384.981 254.579 384.564 254.67C383.972 254.798 382.373 253.915 382.071 253.275C381.901 252.913 382.195 252.521 382.665 252.59C383.187 252.668 384.147 253.251 385.291 253.777Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.259 247.459C352.621 247.562 352.45 247.76 351.754 247.65C350.775 247.496 348.83 246.557 348.23 245.985C347.732 245.511 348.154 245.422 349.532 245.898C350.508 246.235 351.615 246.769 353.259 247.459Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.087 238.793C327.049 239.019 327.234 239.307 326.945 239.282C326.539 239.246 325.035 238.357 324.287 237.725C323.666 237.198 323.663 237.004 324.485 237.377C325.084 237.65 325.953 238.173 327.087 238.793Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.079 232.323C306.098 232.626 306.332 232.969 306.065 232.982C305.689 233.003 304.771 232.512 303.92 231.915C302.871 231.177 302.555 230.642 303.435 230.993C304.043 231.236 304.925 231.738 306.079 232.323Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.044 225.198C280.146 224.907 279.941 224.494 280.341 224.601C280.779 224.718 281.883 225.291 282.509 225.706C283.468 226.338 283.605 226.924 282.723 226.584C282.115 226.348 281.237 225.824 280.044 225.198Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.471 217.143C258.176 217.345 258.149 217.621 257.742 217.58C257.173 217.523 255.858 216.623 255.393 216.002C255.007 215.484 255.201 215.306 256.043 215.694C256.659 215.978 257.417 216.508 258.471 217.143Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.4 207.697C228.661 207.406 228.613 206.994 229.04 207.101C229.506 207.218 230.551 207.794 231.101 208.208C231.943 208.839 231.818 209.424 230.93 209.084C230.316 208.848 229.521 208.322 228.4 207.697Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.606 198.684C202.735 199.866 203.576 200.593 204.012 201.228C204.621 202.117 203.74 202.538 202.8 201.817C202.122 201.299 201.247 200.345 201 199.818C200.776 199.347 201.287 199.19 201.606 198.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.273 194.484C174.139 193.335 173.123 192.522 172.906 192.009C172.683 191.491 173.018 190.967 173.526 190.985C174.366 191.011 176.017 192.437 176.1 193.179C176.155 193.683 175.685 193.895 175.273 194.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.995 186.679C147.594 187.048 147.496 187.415 147.059 187.474C146.433 187.556 145.656 187.092 145.119 186.496C144.447 185.749 144.66 185.165 145.587 185.461C146.214 185.663 146.928 186.13 147.995 186.679Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.651 176.283C115.78 177.307 116.611 177.879 117.035 178.475C117.667 179.367 116.939 180.129 115.915 179.619C115.248 179.287 114.311 178.422 114.061 177.889C113.828 177.391 114.341 177.016 114.651 176.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9972 169.984C89.0798 170.987 89.891 171.542 90.278 172.134C90.8565 173.022 90.0289 173.823 89.0111 173.338C88.3476 173.023 87.4514 172.175 87.2409 171.638C87.0441 171.141 87.6089 170.74 87.9972 169.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6668 167.03C63.0706 167.412 62.7915 167.802 62.2685 167.872C61.5377 167.969 60.8735 167.523 60.5421 166.928C60.1335 166.197 60.6362 165.577 61.5318 165.851C62.1502 166.041 62.7418 166.508 63.6668 167.03Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6653 161.584C35.6542 162.531 36.427 163.039 36.7434 163.621C37.2165 164.493 36.2155 165.396 35.2176 164.979C34.5665 164.708 33.7525 163.903 33.6126 163.367C33.4818 162.865 34.1374 162.401 34.6653 161.584Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.331 158.514C12.6228 158.935 12.2327 159.351 11.6672 159.463C10.8643 159.623 9.84787 158.793 10.1024 158.137C10.2465 157.767 10.9477 157.338 11.4241 157.387C11.9527 157.439 12.5111 158.003 13.331 158.514Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8373 179.783C12.8335 180.786 13.6738 181.359 13.9699 182.034C14.1046 182.344 13.2684 183.039 12.6805 183.239C11.8865 183.508 10.6167 182.494 10.722 181.674C10.7936 181.118 11.2902 180.671 11.8373 179.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8689 181.885C38.9153 182.93 39.7823 183.539 40.114 184.226C40.265 184.539 39.4749 185.187 38.9025 185.354C38.1302 185.58 36.8073 184.511 36.8662 183.703C36.9058 183.155 37.3746 182.737 37.8689 181.885Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8863 186.783C64.9885 187.865 65.8834 188.507 66.2567 189.2C66.4266 189.517 65.6886 190.121 65.1329 190.261C64.3844 190.452 63.0058 189.334 63.013 188.537C63.0175 187.998 63.4542 187.606 63.8863 186.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9478 195.883C94.4809 195.529 93.6415 194.795 93.7455 194.261C93.835 193.795 94.4188 193.621 95.2791 193.961C95.9432 194.224 97.0447 194.912 97.0042 195.085C96.914 195.486 96.2452 195.69 95.9478 195.883Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.038 200.291C127.677 200.543 127.021 200.86 126.047 200.767C125.569 200.72 124.053 199.839 123.843 199.466C123.639 199.102 124.373 198.588 124.899 198.699C125.926 198.915 127.097 199.521 129.038 200.291Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.625 204.984C156.906 206.139 157.89 206.846 158.398 207.553C158.631 207.875 158.085 208.393 157.599 208.477C156.941 208.589 155.389 207.371 155.211 206.599C155.092 206.078 155.41 205.739 155.625 204.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.972 212.684C187.137 213.951 188.121 214.802 188.481 215.476C188.695 215.875 188.082 216.221 187.544 216.18C186.788 216.123 185.374 214.774 185.264 213.991C185.196 213.507 185.615 213.292 185.972 212.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.384 221.784C217.945 221.355 216.847 220.6 216.667 220.097C216.509 219.657 216.923 219.528 217.833 219.907C218.535 220.198 219.825 220.923 219.881 221.086C220.008 221.463 219.54 221.616 219.384 221.784Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.627 229.109C249.635 229.301 249.282 229.581 248.379 229.448C247.935 229.385 246.033 228.472 245.599 228.102C245.178 227.742 245.469 227.276 245.998 227.405C247.027 227.656 248.445 228.289 250.627 229.109Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.16 233.684C275.585 234.867 276.604 235.599 277.274 236.309C277.579 236.635 277.392 237.116 277.067 237.179C276.629 237.262 274.97 236.007 274.52 235.244C274.215 234.728 274.312 234.412 274.16 233.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.231 243.795C303.781 243.996 303.694 244.28 303.173 244.152C302.915 244.089 301.589 243.181 301.232 242.811C300.883 242.449 300.874 241.979 301.198 242.105C301.829 242.352 302.797 242.983 304.231 243.795Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.624 108.813C620.597 109.504 620.703 110.586 620.457 111.42C620.343 111.811 619.414 112.056 619.094 111.742C618.782 111.437 618.597 110.286 618.686 109.572C618.822 108.46 619.806 107.964 620.624 108.813Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.628 131.06C603.593 131.744 603.687 132.786 603.432 133.647C603.312 134.051 602.387 134.459 602.073 134.207C601.768 133.964 601.598 132.875 601.694 132.161C601.843 131.047 602.827 130.378 603.628 131.06Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.978 156.186C585.9 156.861 586.021 157.876 585.577 158.744C585.367 159.151 583.837 159.646 583.328 159.433C582.835 159.226 582.589 158.178 582.769 157.47C583.048 156.363 584.681 155.603 585.978 156.186Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.674 185.612C566.434 185.845 565.643 186.19 565.082 186.052C564.189 185.835 564.178 184.267 565.063 183.475C565.662 182.94 566.89 182.385 567.121 182.654C567.553 183.152 567.465 184.246 567.674 185.612Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.526 209.193C542.952 208.838 543.958 208.352 544.629 208.518C544.934 208.593 544.779 209.97 544.474 210.729C544.064 211.755 542.414 212.382 541.943 211.697C541.625 211.235 541.702 210.399 541.526 209.193Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.7 232.775C518.337 233.997 517.125 233.903 516.791 232.991C516.499 232.192 516.812 231.24 517.722 230.71C518.422 230.301 519.766 230.003 519.87 230.31C520.108 231.022 519.771 232.13 519.7 232.775Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.152 249.801C494.577 249.83 495.577 249.686 496.249 249.918C496.555 250.022 496.415 250.91 496.119 251.359C495.719 251.965 494.077 252.075 493.597 251.534C493.273 251.17 493.342 250.631 493.152 249.801Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.35 261.684C467.786 261.921 468.802 261.942 469.468 262.244C469.769 262.38 469.577 263.143 469.254 263.496C468.816 263.973 467.168 263.828 466.709 263.278C466.401 262.909 466.498 262.446 466.35 261.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.665 269.168C434.414 268.625 434.611 268.185 435.299 268.033C436.355 267.802 438.624 268.406 438.851 268.987C439.02 269.415 438.686 270.092 438.116 270.082C437.074 270.064 435.691 269.62 433.665 269.168Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.863 269.294C406.724 269.518 406.738 269.982 406.235 270.08C406.001 270.124 404.512 269.477 404.052 269.116C403.607 268.763 403.474 268.225 403.711 268.049C404.081 267.777 405.701 268.368 406.863 269.294Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.216 264.679C372.913 264.595 373.075 264.403 373.751 264.518C374.787 264.7 377.111 265.718 377.383 266.119C377.581 266.415 377.3 266.704 376.729 266.53C375.686 266.21 374.269 265.546 372.216 264.679Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.489 257.65C350.521 257.807 350.816 258.187 350.498 258.182C350.349 258.181 348.846 257.411 348.285 257.042C347.741 256.681 347.315 256.212 347.383 256.105C347.49 255.939 349.046 256.693 350.489 257.65Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.761 251.883C326.532 251.467 325.243 250.712 324.738 250.207C324.296 249.764 324.443 249.625 325.308 249.999C325.973 250.288 327.342 251.005 327.505 251.168C327.885 251.55 327.723 251.712 327.761 251.883Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.11 235.084C325.877 234.923 325.547 234.923 324.994 234.779C324.078 234.538 322.868 233.977 322.076 233.367C321.734 233.103 321.866 232.889 322.282 233.029C323 233.271 324.105 233.817 327.11 235.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.209 243.483C356.966 242.802 355.98 242.322 355.311 241.847C355.067 241.673 355.343 241.334 355.783 241.389C356.61 241.491 357.799 241.952 358.389 242.629C358.654 242.937 358.318 243.081 358.209 243.483Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.135 245.278C391.847 245.871 391.488 246.147 390.919 246.246C389.978 246.41 388.784 246.034 388.06 245.185C387.747 244.822 387.941 244.184 388.362 244.184C389.089 244.186 390.175 244.604 393.135 245.278Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.283 242.082C420.778 242.366 421.521 242.378 422.084 242.621C422.812 242.933 422.655 243.967 421.851 244.113C420.968 244.276 419.96 244.19 419.495 243.404C419.248 242.983 419.342 242.53 419.283 242.082Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.008 233.773C451.497 233.751 452.233 233.602 452.796 233.745C453.526 233.932 453.395 235.133 452.6 235.48C451.729 235.862 450.725 235.993 450.248 235.211C449.993 234.794 450.077 234.263 450.008 233.773Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.078 219.684C479.569 220.668 479.549 221.08 479.178 221.333C478.488 221.804 477.544 221.967 477.016 221.522C476.492 221.079 477.025 220.598 477.917 220.266C478.482 220.055 479.122 219.941 480.078 219.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.88 198.684C506.636 199.837 506.711 200.434 506.353 200.968C505.64 202.036 504.518 202.419 503.802 202.042C503.487 201.873 503.584 200.863 503.938 200.52C504.577 199.901 505.549 199.494 506.88 198.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.413 173.484C530.294 174.615 530.358 175.194 530.151 175.729C529.736 176.794 529.046 177.21 528.589 176.867C528.387 176.714 528.417 175.723 528.627 175.375C529.009 174.748 529.603 174.317 530.413 173.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.462 148.549C552.218 148.426 552.765 148.179 553.012 148.331C553.554 148.67 553.254 149.428 552.615 149.986C552.28 150.276 551.456 150.488 551.394 150.328C551.243 149.938 551.408 149.308 551.462 148.549Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.368 120.493C571.132 120.404 571.684 120.176 571.942 120.347C572.51 120.72 572.233 121.484 571.604 122.024C571.274 122.308 570.443 122.488 570.372 122.321C570.202 121.911 570.344 121.27 570.368 120.493Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.247 95.084C588.587 96.6044 588.423 97.1833 588.101 97.6824C587.566 98.5077 586.777 98.8667 586.177 98.3291C585.918 98.0981 585.91 97.1875 586.163 96.9019C586.598 96.4105 587.328 96.1592 589.247 95.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.936 74.7852C604.55 76.3559 604.46 76.9782 604.268 77.4787C603.954 78.3103 603.477 78.5861 603.106 77.8875C602.946 77.5858 602.928 76.5645 603.077 76.2894C603.336 75.8113 603.776 75.6475 604.936 74.7852Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.572 60.7852C620.568 61.6216 620.712 62.1334 620.54 62.4427C620.195 63.0615 619.467 63.0013 618.909 62.4462C618.662 62.1998 618.575 61.3934 618.771 61.2338C619.126 60.944 619.747 60.9518 620.572 60.7852Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.039 225.838C304.128 226.279 304.318 226.661 304.184 226.682C303.914 226.723 303.196 226.086 302.597 225.335C302.332 225.002 302.167 224.513 302.342 224.593C302.658 224.739 303.263 225.257 304.039 225.838Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.884 218.158C283.903 218.588 284.055 218.966 283.89 218.982C283.56 219.012 282.83 218.37 282.264 217.62C282.014 217.288 281.914 216.808 282.105 216.893C282.453 217.044 283.072 217.567 283.884 218.158Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.471 208.482C259.902 209.186 260.593 209.475 261.162 209.817C261.897 210.258 261.944 210.748 261.222 210.528C260.431 210.286 259.483 209.873 258.91 209.276C258.607 208.959 258.609 208.747 258.471 208.482Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.592 204.283C234.848 204.186 234.488 204.305 233.902 203.999C233.562 203.82 232.86 202.953 232.323 202.394C232.676 202.319 232.91 202.071 233.428 202.243C233.667 202.32 234.466 203.212 235.592 204.283Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.751 194.894C210.632 195.401 210.806 195.975 210.459 195.871C209.639 195.626 208.574 195.059 207.61 194.621C207.603 194.322 207.299 193.727 207.654 193.788C208.334 193.902 209.39 194.39 210.751 194.894Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.525 185.385C180.926 186.046 181.697 186.335 182.247 186.683C182.962 187.134 182.644 187.651 181.778 187.434C180.832 187.196 179.788 186.776 179.441 186.164C179.263 185.846 179.484 185.647 179.525 185.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.839 179.573C154.914 179.699 154.628 179.823 154.245 179.772C153.609 179.684 152.911 179.154 152.607 178.375C152.477 178.039 152.719 177.606 152.988 177.696C153.452 177.851 154.067 178.382 155.839 179.573Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.037 170.464C128.552 170.941 128.449 171.34 128.037 171.379C127.21 171.455 126.26 170.838 125.825 170.079C125.632 169.744 125.971 169.223 126.328 169.291C126.972 169.413 127.811 169.912 129.037 170.464Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5044 162.984C98.8106 163.609 99.5675 163.875 100.036 164.216C100.644 164.659 100 165.233 99.0988 165.049C98.1104 164.85 97.1037 164.463 97.0102 163.824C96.9606 163.494 97.3227 163.267 97.5044 162.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.702 159.485C71.0724 158.783 70.4174 158.227 70.2076 157.72C70.1344 157.541 71.0894 157.338 71.6837 157.394C72.5825 157.48 73.7455 158.489 73.4147 158.867C73.1735 159.144 72.5309 159.204 71.702 159.485Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5807 154.584C46.0485 153.956 45.5831 153.538 45.3713 153.083C45.2942 152.915 45.7589 152.482 46.078 152.484C46.6767 152.492 47.3187 152.878 47.3239 153.585C47.3259 153.903 46.9552 154.107 46.5807 154.584Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0809 148.984C22.4553 149.364 22.8707 149.644 23.0705 150.019C23.3398 150.528 22.7276 151.307 22.2438 151.024C21.8211 150.778 21.5245 150.155 21.1753 149.7C21.4582 149.475 21.7411 149.252 22.0809 148.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.15694 145.484C-0.464075 146.009 -0.0364193 146.206 0.182638 146.525C0.465039 146.94 -0.104406 147.663 -0.645086 147.577C-1.23761 147.483 -1.79208 147.184 -1.6918 146.486C-1.63996 146.126 -1.34828 145.825 -1.15694 145.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.251 228.783C329.411 229.485 330.627 230.105 330.924 230.42C331.224 230.736 330.859 231.001 330.347 230.829C329.738 230.626 328.258 229.812 327.893 229.476C327.522 229.137 328.05 229.063 328.251 228.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.643 235.783C362.787 236.379 363.993 236.855 364.275 237.183C364.562 237.514 364.167 237.957 363.65 237.873C363.037 237.774 361.571 237.119 361.22 236.782C360.863 236.442 361.415 236.2 361.643 235.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.364 237.354C397.528 237.539 396.959 237.865 396.46 237.701C395.934 237.531 395.085 236.779 395.096 236.487C395.108 236.166 395.921 235.828 396.412 235.943C396.948 236.071 397.513 236.716 398.364 237.354Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.743 233.759C429.148 234.326 428.813 234.975 428.299 235.032C427.746 235.093 426.579 234.644 426.49 234.335C426.374 233.927 426.892 233.201 427.42 233.052C427.868 232.924 428.719 233.426 429.743 233.759Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.159 219.684C458.479 220.645 458.217 221.322 457.715 221.611C457.239 221.882 456.509 221.743 455.891 221.78C455.99 221.252 455.893 220.58 456.25 220.236C456.564 219.933 457.39 220.003 459.159 219.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.402 203.296C484.202 203.116 484.965 202.744 485.195 202.937C485.445 203.148 485.203 203.878 485.177 204.382C484.6 204.603 483.829 205.085 483.502 204.963C483.212 204.855 483.419 204.078 483.402 203.296Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.11 179.783C511.758 180.578 511.562 181.343 511.252 181.617C510.921 181.912 510.214 181.983 510.16 181.723C510.087 181.38 510.394 180.46 510.71 180.09C510.978 179.776 511.492 179.895 512.11 179.783Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.643 153.184C535.245 154.491 535.097 155.344 534.795 155.842C534.509 156.317 534.06 156.418 533.682 156.684C533.732 156.053 533.661 155.337 533.872 154.817C534.056 154.369 534.562 154.147 535.643 153.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.601 125.885C554.284 126.679 554.131 127.45 553.822 127.723C553.489 128.018 552.742 128.082 552.663 127.82C552.561 127.471 552.817 126.544 553.127 126.176C553.391 125.862 553.949 125.987 554.601 125.885Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.943 99.9848C571.246 99.1378 571.359 98.3419 571.679 98.0563C571.982 97.7875 572.701 97.8477 572.865 98.1452C573.007 98.4 572.735 99.38 572.438 99.6971C572.148 100.007 571.595 99.8833 570.943 99.9848Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.208 76.1855C590.818 77.3475 590.781 77.9621 590.504 78.1651C590.2 78.3863 589.673 78.2323 589.247 78.2442C589.335 77.7822 589.289 77.204 589.555 76.8925C589.831 76.5684 590.407 76.5005 591.208 76.1855Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.771 57.9844C606.797 58.7943 607.037 59.5565 606.778 59.8022C606.465 60.0983 605.566 60.1873 605.227 59.943C604.929 59.7288 604.836 58.7859 605.06 58.4212C605.257 58.1048 606.02 58.1454 606.771 57.9844Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.586 48.1867C622.243 48.8685 622.15 49.4712 621.851 49.5713C621.571 49.6658 621.076 49.2346 620.673 49.0379C620.676 48.5129 620.534 47.7618 620.726 47.5357C620.895 47.3411 621.442 47.7303 622.586 48.1867Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.27 218.984C303.007 219.629 303.716 220.179 303.988 220.503C304.263 220.827 304.322 221.184 304.076 221.058C303.786 220.911 302.889 220.183 302.587 219.847C302.282 219.507 302.382 219.338 302.27 218.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.966 213.383C283.116 212.675 282.306 212.078 282.102 211.807C281.86 211.485 282.141 211.445 282.195 211.283C282.744 211.728 283.472 212.244 283.788 212.595C284.075 212.914 283.912 213.056 283.966 213.383Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.7 204.846C263.138 204.893 262.983 205.103 262.485 204.888C262.016 204.682 261.186 204.028 260.516 203.57C260.519 203.318 260.278 202.824 260.599 202.889C260.883 202.947 261.799 203.634 263.7 204.846Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.552 194.484C238.337 195.055 239.059 195.49 239.323 195.791C239.608 196.121 239.467 196.325 239.514 196.584C238.958 196.225 238.242 195.852 237.897 195.513C237.588 195.207 237.685 194.94 237.552 194.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.337 186.084C213.034 186.736 213.765 187.297 213.949 187.618C214.134 187.943 213.924 188.287 213.615 188.155C213.251 187.999 212.359 187.263 212.137 186.927C211.912 186.587 212.225 186.429 212.337 186.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.485 179.627C189.77 179.686 189.471 179.905 188.971 179.693C188.498 179.494 187.808 178.841 187.217 178.388C187.346 178.131 187.297 177.628 187.659 177.689C187.977 177.74 188.758 178.424 190.485 179.627Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.684 172.573C163.501 172.996 163.517 173.566 163.224 173.473C162.87 173.362 162.053 172.665 161.817 172.266C161.61 171.913 161.768 171.377 162.059 171.383C162.311 171.388 162.976 172.039 163.684 172.573Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.355 162.984C136.015 163.57 136.714 164.034 136.852 164.345C136.995 164.669 136.594 164.845 136.431 165.084C135.922 164.708 135.181 164.304 134.974 163.965C134.782 163.651 135.16 163.409 135.355 162.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.387 158.521C110.562 158.642 110.156 158.903 109.662 158.721C109.195 158.545 108.636 157.907 108.119 157.472C108.348 157.183 108.454 156.652 108.843 156.685C109.182 156.715 109.837 157.377 111.387 158.521Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9707 150.064C81.6733 150.536 81.553 151.142 81.2615 151.08C80.9098 151.003 80.2018 150.356 80.0443 149.957C79.9063 149.607 80.2031 149.014 80.513 148.985C80.781 148.961 81.3399 149.575 81.9707 150.064Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7837 144.405C57.4562 144.903 57.3 145.53 57.0091 145.48C56.6587 145.421 55.9834 144.798 55.8475 144.401C55.7278 144.052 56.0606 143.432 56.3756 143.385C56.6456 143.344 57.1738 143.942 57.7837 144.405Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4097 139.184C32.9383 139.71 33.5501 140.102 33.5931 140.416C33.6375 140.743 33.1312 140.998 32.8661 141.284C32.4346 140.957 31.759 140.637 31.648 140.304C31.5467 139.994 32.0476 139.671 32.4097 139.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7165 136.113C9.98421 136.702 9.69063 137.185 9.45386 137.066C9.19316 136.938 8.98521 136.256 8.75537 135.815C9.00711 135.515 9.23696 134.971 9.51655 134.985C9.80607 134.995 10.1424 135.544 10.7165 136.113Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.231 215.168C303.833 215.308 303.813 215.63 303.283 215.406C302.79 215.197 301.755 214.403 300.962 213.864C301.07 213.692 300.911 213.252 301.364 213.421C301.845 213.597 302.91 214.356 304.231 215.168Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.877 225.992C338.455 226.301 338.403 226.729 337.876 226.609C337.384 226.494 336.384 225.795 335.608 225.349C335.737 225.089 335.612 224.57 336.067 224.644C336.548 224.719 337.584 225.36 338.877 225.992Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.217 229.745C371.781 230.21 371.714 230.716 371.185 230.718C370.698 230.722 369.715 230.189 368.948 229.886C369.087 229.554 368.978 228.992 369.435 228.952C369.919 228.912 370.937 229.367 372.217 229.745Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.953 229.479C404.335 228.975 403.691 228.648 403.605 228.31C403.522 227.988 403.954 227.411 404.291 227.388C404.648 227.363 405.423 227.82 405.534 228.129C405.658 228.473 405.236 228.889 404.953 229.479Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.213 218.984C434.872 219.319 435.567 219.446 435.619 219.748C435.685 220.127 435.317 220.865 434.958 221.042C434.647 221.196 433.878 220.902 433.698 220.581C433.547 220.311 433.952 219.722 434.213 218.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.389 207.084C464.143 207.898 464.121 208.543 463.804 208.86C463.51 209.154 462.9 209.094 462.427 209.184C462.5 208.704 462.416 208.094 462.69 207.776C462.979 207.44 463.608 207.385 464.389 207.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.191 185.385C490.925 186.1 490.876 186.637 490.561 186.956C490.266 187.254 489.685 187.318 489.229 187.485C489.319 187.075 489.264 186.587 489.538 186.274C489.83 185.943 490.434 185.777 491.191 185.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.685 159.484C516.297 160.363 516.129 161.041 515.822 161.344C515.531 161.628 515.096 161.521 514.724 161.584C514.907 161.089 515.007 160.476 515.296 160.13C515.569 159.806 516.041 159.764 516.685 159.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.258 130.785C537.887 131.664 537.738 132.345 537.431 132.649C537.14 132.933 536.682 132.822 536.296 132.885C536.468 132.387 536.547 131.77 536.836 131.425C537.107 131.099 537.597 131.061 538.258 130.785Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.664 103.514C556.379 103.549 557.107 103.358 557.193 103.649C557.3 104.013 557 104.952 556.647 105.308C556.346 105.616 555.516 105.681 555.305 105.429C555.123 105.211 555.477 104.396 555.664 103.514Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.827 78.2852C576.495 79.2105 576.387 79.9567 576.076 80.2458C575.784 80.5174 575.277 80.3074 574.865 80.3102C575.011 79.7726 575.046 79.0831 575.332 78.7437C575.601 78.4245 576.13 78.4721 576.827 78.2852Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.169 57.9844C593.02 58.8125 593.097 59.4865 592.785 59.8022C592.498 60.0955 591.793 60.0046 591.273 60.0844C591.278 59.5797 591.083 58.9301 591.346 58.6102C591.621 58.2714 592.326 58.2434 593.169 57.9844Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.199 41.8848C607.952 42.2684 608.703 42.4608 608.818 42.7583C608.957 43.1328 608.713 43.8139 608.37 43.9581C608.074 44.0834 607.208 43.7419 606.967 43.4129C606.758 43.1294 607.067 42.5743 607.199 41.8848Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.445 204.984C284.252 205.762 285.032 206.423 285.186 206.676C285.38 206.991 285.232 207.194 284.908 207.021C284.63 206.875 283.719 206.044 283.424 205.672C283.176 205.362 283.411 205.283 283.445 204.984Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.355 198.409C264.07 198.525 264.013 198.838 263.699 198.588C263.404 198.355 262.839 197.529 262.394 196.962C262.508 196.828 262.493 196.448 262.774 196.635C263.045 196.813 263.621 197.575 264.355 198.409Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.144 188.184C241.891 188.964 242.638 189.633 242.746 189.885C242.88 190.198 242.622 190.394 242.277 190.216C241.979 190.064 241.129 189.227 240.886 188.858C240.684 188.548 241.003 188.474 241.144 188.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.053 181.883C217.764 182.664 218.49 183.33 218.575 183.582C218.68 183.895 218.372 184.093 218.018 183.917C217.714 183.766 216.898 182.929 216.684 182.559C216.504 182.25 216.86 182.174 217.053 181.883Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.062 174.895C194.819 175.226 194.795 175.685 194.478 175.565C194.181 175.452 193.571 174.722 193.101 174.263C193.174 173.98 193.091 173.424 193.364 173.49C193.649 173.559 194.278 174.227 195.062 174.895Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.567 166.47C169.288 166.815 169.222 167.28 168.904 167.166C168.612 167.061 168.049 166.332 167.606 165.88C167.707 165.59 167.668 165.027 167.944 165.089C168.234 165.154 168.821 165.816 169.567 166.47Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.726 158.404C144.287 158.579 144.067 158.935 143.76 158.713C143.475 158.507 143.1 157.689 142.765 157.139C142.979 156.974 143.13 156.563 143.423 156.718C143.699 156.864 144.126 157.608 144.726 158.404Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.105 151.085C117.422 150.448 116.754 149.983 116.64 149.668C116.524 149.344 116.858 148.916 117.167 148.994C117.55 149.092 118.347 149.692 118.533 150.03C118.709 150.351 118.328 150.612 118.105 151.085Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3013 142.684C93.8171 143.422 94.4185 144.035 94.3904 144.296C94.3551 144.62 93.8334 144.883 93.4601 144.746C93.1398 144.629 92.5103 143.841 92.4358 143.478C92.3691 143.163 92.8862 143.028 93.3013 142.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2243 137.085C66.7831 136.364 66.2575 135.785 66.2823 135.462C66.3078 135.155 66.9217 134.88 67.2596 135.024C67.6192 135.176 68.233 135.94 68.2428 136.252C68.2526 136.597 67.7009 136.731 67.2243 137.085Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7092 132.272C44.1705 132.572 43.8456 133.008 43.5436 132.85C43.2645 132.702 43.0115 131.921 42.748 131.42C43.0259 131.186 43.2854 130.703 43.5854 130.794C43.8685 130.882 44.196 131.569 44.7092 132.272Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2989 126.584C20.7152 127.262 21.2472 127.803 21.1674 128.074C21.0673 128.41 20.4554 128.756 20.0783 128.671C19.7559 128.596 19.2285 127.885 19.2145 127.524C19.2051 127.212 19.7856 126.998 20.2989 126.584Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.257507 124.743C-0.194727 125.286 -0.452811 125.883 -0.762406 125.885C-1.04899 125.888 -1.38853 125.256 -1.70361 124.901C-1.47952 124.505 -1.30028 123.836 -1.01775 123.788C-0.719001 123.738 -0.322396 124.28 0.257507 124.743Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9263 107.684C19.6851 107.09 19.3772 106.536 19.3026 105.994C19.2811 105.837 20.1734 105.532 20.2224 105.592C20.5872 106.055 20.9068 106.584 21.0873 107.118C21.1206 107.217 20.4656 107.429 19.9263 107.684Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9774 109.084C40.6207 109.51 41.007 109.766 41.3953 110.025C41.107 110.412 40.8188 110.799 40.5305 111.184C40.1755 110.924 39.5264 110.595 39.5244 110.417C39.5225 109.95 39.799 109.548 39.9774 109.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6283 115.527C65.1858 115.691 64.7399 115.857 64.2935 116.025C64.0705 115.586 63.5835 114.918 63.6796 114.756C63.8993 114.387 64.4039 114.265 64.7916 114.045C65.0237 114.457 65.2551 114.868 65.6283 115.527Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.086 122.385C87.754 121.746 87.3591 121.138 87.2022 120.575C87.1565 120.411 88.0024 120.229 88.0605 120.301C88.4953 120.825 88.8953 121.409 89.1588 121.978C89.2078 122.083 88.5868 122.205 88.086 122.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.695 128.412C112.234 128.389 111.807 128.456 111.326 128.283C111.204 128.239 110.654 127.11 110.743 127.044C111.026 126.835 111.521 126.897 111.933 126.855C112.144 127.286 112.354 127.719 112.695 128.412Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.882 135.37C136.779 135.826 136.715 136.106 136.652 136.385C136.085 135.974 135.44 135.594 134.992 135.135C134.806 134.94 135.04 134.574 135.084 134.285C135.679 134.644 136.275 135.004 136.882 135.37Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.578 144.774C159.166 144.113 158.708 143.481 158.459 142.914C158.387 142.748 159.071 142.643 159.136 142.718C159.613 143.273 160.069 143.886 160.41 144.468C160.473 144.577 159.968 144.64 159.578 144.774Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.229 153.164C180.789 152.505 180.31 151.872 180.033 151.308C179.954 151.142 180.585 151.056 180.651 151.131C181.14 151.688 181.617 152.297 181.981 152.878C182.048 152.985 181.582 153.038 181.229 153.164Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.226 159.484C205 159.93 205.869 160.378 205.905 160.457C206.101 160.884 206.097 161.219 206.163 161.584C205.705 161.316 204.973 160.974 204.842 160.795C204.502 160.336 204.424 159.947 204.226 159.484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.713 169.878C225.26 169.23 224.764 168.6 224.489 168.075C224.4 167.909 224.899 168.035 225.129 168.026C225.575 168.606 226.097 169.213 226.428 169.746C226.52 169.895 226.043 169.828 225.713 169.878Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.666 177.958C248.407 178.04 248.144 178.119 247.881 178.201C247.467 177.765 246.717 177.074 246.706 176.939C246.683 176.637 247.016 176.605 247.206 176.467C247.609 176.88 248.014 177.296 248.666 177.958Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.316 185.385C266.98 185.829 267.707 186.276 267.755 186.354C268.019 186.781 268.119 187.116 268.277 187.485C267.883 187.217 267.279 186.873 267.138 186.698C266.762 186.235 266.592 185.847 266.316 185.385Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.442 195.728C286.014 195.058 285.544 194.388 285.28 193.855C285.202 193.7 285.86 193.907 285.925 193.989C286.41 194.607 286.876 195.256 287.229 195.833C287.294 195.94 286.808 195.787 286.442 195.728Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.057 206.916C320.64 206.338 320.179 205.778 319.925 205.286C319.852 205.143 320.531 205.122 320.595 205.188C321.074 205.685 321.533 206.225 321.876 206.733C321.939 206.828 321.44 206.84 321.057 206.916Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.527 211.47C356.463 211.941 356.426 212.231 356.388 212.52C355.799 212.224 355.133 211.972 354.654 211.601C354.455 211.445 354.653 211.04 354.67 210.748C355.285 210.992 355.901 211.229 356.527 211.47Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.173 211.177C391.105 211.706 391.066 212.031 391.026 212.356C390.439 212.199 389.774 212.111 389.299 211.842C389.1 211.728 389.303 211.234 389.322 210.91C389.937 211.003 390.55 211.091 391.173 211.177Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.708 204.824C421.297 204.501 420.84 204.247 420.596 203.871C420.524 203.76 421.218 203.02 421.281 203.041C421.757 203.191 422.211 203.417 422.546 203.724C422.608 203.781 422.1 204.322 421.708 204.824Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.354 192.253C450.232 192.022 451.222 191.673 451.248 191.759C451.381 192.234 451.278 192.814 451.261 193.353C450.747 193.481 449.9 193.824 449.783 193.689C449.471 193.339 449.481 192.78 449.354 192.253Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.117 170.105C479.009 169.723 480.019 169.215 480.037 169.291C480.145 169.708 480.011 170.269 479.963 170.779C479.442 170.995 478.574 171.473 478.464 171.368C478.173 171.098 478.213 170.573 478.117 170.105Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.726 144.156C504.534 143.806 505.019 143.594 505.503 143.383C505.362 143.916 505.223 144.45 505.083 144.982C504.628 145.159 503.85 145.577 503.781 145.464C503.597 145.165 503.722 144.634 503.726 144.156Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.961 117.485C528.536 117.35 528.066 117.341 527.804 117.028C527.728 116.937 528.392 115.509 528.458 115.493C528.938 115.357 529.402 115.337 529.754 115.504C529.818 115.534 529.332 116.57 528.961 117.485Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.026 87.403C547.672 87.0761 548.058 86.8808 548.446 86.6855C548.376 87.2322 548.305 87.7768 548.238 88.3221C547.872 88.4845 547.258 88.8842 547.189 88.7631C547.007 88.4446 547.066 87.8986 547.026 87.403Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.42 61.3921C564.018 61.1149 564.378 60.949 564.739 60.7852C564.694 61.3571 564.649 61.9283 564.608 62.5001C564.266 62.631 563.698 62.9908 563.63 62.855C563.443 62.4966 563.476 61.9233 563.42 61.3921Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.35 39.0859C580.431 39.767 580.484 40.1989 580.539 40.6315C580.097 40.8359 579.637 41.1649 579.229 41.1859C579.087 41.1894 578.932 40.1646 579.029 40.0575C579.409 39.6389 579.886 39.4037 580.35 39.0859Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.295 25.7855C595.929 25.3515 595.529 24.991 595.311 24.5318C595.242 24.3876 595.664 23.9746 595.86 23.6855C596.223 24.025 596.646 24.3218 596.909 24.7327C596.984 24.8503 596.58 25.313 596.295 25.7855Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.101 20.8041C611.675 20.2959 611.224 19.836 610.938 19.353C610.855 19.2123 611.348 18.8175 611.41 18.87C611.861 19.2459 612.31 19.689 612.663 20.1489C612.732 20.235 612.365 20.5017 612.101 20.8041Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0567 115.881C9.34682 115.752 8.75064 115.675 8.17407 115.49C8.12112 115.473 8.03287 114.551 8.22702 114.408C8.52119 114.19 9.14678 114.1 9.45272 114.303C9.73904 114.495 9.79199 115.135 10.0567 115.881Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6349 118.842C31.3378 119.042 31.0424 119.237 30.747 119.437C30.3875 118.92 30.0297 118.405 29.6738 117.889C30.0774 117.799 30.5104 117.528 30.881 117.677C31.1708 117.794 31.3854 118.433 31.6349 118.842Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5143 123.79C54.2332 123.973 53.9561 124.153 53.6769 124.334C53.3004 123.803 52.9258 123.269 52.5532 122.738C52.9448 122.669 53.354 122.423 53.7234 122.591C54.0116 122.723 54.2509 123.37 54.5143 123.79Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0478 128.567C77.3712 128.328 76.8064 128.158 76.2409 127.885C76.1919 127.86 75.9854 126.929 76.1475 126.816C76.392 126.648 76.962 126.659 77.2732 126.908C77.5647 127.142 77.7007 127.786 78.0478 128.567Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.874 134.562C102.212 134.953 102.549 135.346 102.889 135.736C102.476 135.86 102.064 135.984 101.651 136.108C101.39 135.673 100.866 135.014 100.934 134.854C101.045 134.586 101.539 134.642 101.874 134.562Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.115 141.165C125.357 141.029 125.595 140.892 125.835 140.758C126.247 141.333 126.661 141.911 127.076 142.486C126.728 142.467 126.386 142.599 126.029 142.377C125.735 142.194 125.42 141.587 125.115 141.165Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.571 150.526C152.373 150.661 152.174 150.795 151.974 150.929C151.518 150.356 151.062 149.785 150.61 149.216C150.935 149.207 151.23 149.031 151.592 149.249C151.876 149.42 152.24 150.081 152.571 150.526Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.104 158.763C175.979 158.961 175.859 159.152 175.738 159.343C175.205 158.767 174.673 158.19 174.143 157.61C174.451 157.596 174.707 157.419 175.081 157.623C175.365 157.776 175.803 158.419 176.104 158.763Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.055 166.111C199.469 166.517 199.88 166.92 200.292 167.323C199.976 167.401 199.656 167.478 199.338 167.556C198.98 167.119 198.322 166.443 198.331 166.296C198.346 166.053 198.791 166.155 199.055 166.111Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.825 176.212C223.269 175.893 222.814 175.653 222.321 175.315C222.277 175.286 221.798 174.389 221.872 174.309C221.982 174.186 222.383 174.28 222.688 174.557C222.976 174.818 223.301 175.437 223.825 176.212Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.397 183.968C245.35 184.151 245.304 184.329 245.258 184.508C244.649 183.945 244.041 183.384 243.436 182.824C243.689 182.817 243.852 182.658 244.222 182.859C244.501 183.015 245.048 183.632 245.397 183.968Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.897 192.049C265.369 192.433 265.842 192.817 266.316 193.2C266.081 193.273 265.846 193.347 265.61 193.418C265.169 193.002 264.404 192.36 264.362 192.219C264.295 191.99 264.695 192.089 264.897 192.049Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.636 31.1741C607.763 30.8612 607.89 30.5525 608.021 30.248C608.488 30.5756 608.955 30.9011 609.426 31.2329C609.173 31.4429 608.973 31.8125 608.651 31.823C608.387 31.8314 607.978 31.4051 607.636 31.1741Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.813 42.1167C593.268 42.5556 592.825 42.9609 592.342 43.2612C592.299 43.2864 591.811 42.5556 591.878 42.2742C591.978 41.8479 592.366 41.2725 592.668 41.2116C592.954 41.1528 593.286 41.6694 593.813 42.1167Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.331 60.0844C576.984 60.0746 576.636 60.0647 576.289 60.0591C576.58 59.3641 576.87 58.6732 577.16 57.9844C577.466 58.1874 577.995 58.2812 578.017 58.6242C578.041 58.9854 577.58 59.5846 577.331 60.0844Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.513 83.0309C560.672 82.4051 560.833 81.7857 560.992 81.1641C561.466 81.1662 561.941 81.1683 562.415 81.1725C562.135 81.7836 561.896 82.5857 561.553 82.949C561.27 83.2472 560.864 83.0225 560.513 83.0309Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.206 109.084C543.27 109.422 543.335 109.759 543.402 110.098C542.806 110.459 542.21 110.821 541.612 111.184C541.708 110.756 541.67 110.269 541.933 109.919C542.201 109.568 542.768 109.355 543.206 109.084Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.608 139.184C520.8 138.549 520.993 137.916 521.185 137.281C521.646 137.215 522.107 137.148 522.569 137.084C522.257 137.729 521.978 138.555 521.621 138.96C521.33 139.294 520.95 139.13 520.608 139.184Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.035 165.432C498.433 166.103 497.933 166.684 497.412 167.181C497.364 167.226 496.985 166.779 497.093 166.49C497.256 166.053 497.726 165.344 498.035 165.142C498.327 164.953 498.579 165.273 499.035 165.432Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.272 190.596C470.08 191.1 469.888 191.602 469.695 192.101C469.234 192.131 468.773 192.158 468.311 192.185C468.632 191.639 468.923 190.923 469.284 190.598C469.567 190.344 469.94 190.579 470.272 190.596Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.299 205.225C442.689 205.267 443.08 205.309 443.47 205.349C443.125 205.85 442.78 206.351 442.436 206.844C442.105 206.687 441.485 206.571 441.51 206.361C441.553 206.015 442.014 205.609 442.299 205.225Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.943 216.038C413.98 216.377 414.017 216.713 414.053 217.049C413.4 217.055 412.747 217.057 412.092 217.057C412.229 216.727 412.234 216.272 412.542 216.106C412.853 215.936 413.464 216.051 413.943 216.038Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.099 220.691C378.303 220.479 378.506 220.269 378.71 220.057C379.16 220.403 379.61 220.745 380.06 221.088C379.74 221.21 379.447 221.459 379.09 221.403C378.798 221.354 378.433 220.943 378.099 220.691Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.488 220.614C346.129 220.297 345.772 219.979 345.415 219.66C345.799 219.589 346.184 219.511 346.569 219.436C346.859 219.809 347.394 220.328 347.375 220.515C347.356 220.714 346.806 220.597 346.488 220.614Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.076 212.299C311.902 212.357 311.728 212.414 311.555 212.473C311.073 211.914 310.594 211.354 310.115 210.793C310.418 210.871 310.681 210.803 311.041 211.062C311.322 211.265 311.725 211.872 312.076 212.299Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.699 201.08C284.891 201.391 285.081 201.7 285.273 202.009C284.658 201.608 284.042 201.204 283.426 200.801C283.403 200.604 283.195 200.217 283.407 200.264C283.623 200.312 284.25 200.791 284.699 201.08Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.395 7.26169C621.752 7.80138 622.199 8.41248 622.413 8.83667C622.481 8.97317 621.936 8.62877 621.669 8.50277C621.432 8.05968 620.981 7.43389 620.795 7.01599C620.752 6.9236 621.287 7.26169 621.395 7.26169Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0303 84.0235C17.8714 84.3343 17.693 84.685 17.5145 85.0357C17.3772 84.8404 17.1027 84.5884 17.1321 84.4624C17.2203 84.0928 17.4302 83.7757 17.591 83.4355C17.7341 83.6287 17.8753 83.8177 18.0303 84.0235Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9196 87.4839C40.7568 87.8367 40.5921 88.1874 40.4293 88.536C40.2764 88.3386 39.9783 88.0782 40.0018 87.9564C40.0724 87.5847 40.2685 87.2697 40.4176 86.9316C40.5843 87.1143 40.751 87.2991 40.9196 87.4839Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8327 92.4722C61.6875 92.7683 61.5248 93.0994 61.362 93.4333C61.2071 93.2233 60.9051 92.9405 60.9266 92.8145C60.9953 92.4547 61.1933 92.1572 61.3385 91.8359C61.4993 92.041 61.6601 92.2496 61.8327 92.4722Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9454 98.1484C83.118 98.5705 83.3416 99.0017 83.4377 99.4105C83.469 99.5428 83.1631 99.6184 83.0121 99.7213C82.8199 99.274 82.5885 98.8253 82.463 98.3864C82.4355 98.2877 82.7748 98.2261 82.9454 98.1484Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.568 106.449C107.454 106.777 107.338 107.109 107.222 107.436C107.042 107.22 106.703 106.922 106.709 106.802C106.728 106.441 106.881 106.151 106.983 105.832C107.179 106.038 107.371 106.244 107.568 106.449Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.12 112.765C129.028 113.09 128.936 113.412 128.845 113.735C128.653 113.514 128.302 113.208 128.302 113.09C128.298 112.733 128.432 112.448 128.51 112.135C128.714 112.345 128.916 112.555 129.12 112.765Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.982 121.237C151.909 121.51 151.829 121.817 151.751 122.126C151.556 121.897 151.205 121.576 151.199 121.458C151.182 121.11 151.303 120.843 151.37 120.545C151.57 120.77 151.768 120.996 151.982 121.237Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.98 128.963C173.237 129.393 173.541 129.836 173.723 130.246C173.784 130.378 173.525 130.42 173.411 130.504C173.131 130.049 172.815 129.582 172.599 129.139C172.55 129.043 172.843 129.02 172.98 128.963Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.675 138.654C194.583 138.74 194.489 138.83 194.394 138.918C194.086 138.465 193.743 138.005 193.496 137.566C193.437 137.459 193.694 137.419 193.804 137.348C194.09 137.778 194.377 138.207 194.675 138.654Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.748 148.582C215.03 149.006 215.354 149.448 215.568 149.853C215.636 149.981 215.407 150.013 215.315 150.088C215.009 149.637 214.671 149.178 214.426 148.742C214.371 148.645 214.632 148.63 214.748 148.582Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.643 156.992C235.929 157.412 236.257 157.847 236.478 158.244C236.549 158.37 236.339 158.401 236.257 158.475C235.947 158.032 235.606 157.58 235.353 157.15C235.296 157.053 235.537 157.04 235.643 156.992Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.509 166.058C254.525 166.31 254.542 166.594 254.562 166.877C254.36 166.659 254.019 166.348 253.984 166.235C253.884 165.911 253.905 165.666 253.882 165.391C254.086 165.607 254.29 165.825 254.509 166.058Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.816 175.324C273.697 175.515 273.563 175.731 273.434 175.946C273.122 175.685 272.555 175.289 272.545 175.19C272.52 174.902 272.718 174.734 272.83 174.52C273.149 174.782 273.469 175.042 273.816 175.324Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.707 187.629C310.511 187.694 310.315 187.762 310.116 187.829C309.689 187.418 309.199 186.993 308.877 186.596C308.801 186.502 309.281 186.492 309.505 186.441C309.899 186.834 310.295 187.225 310.707 187.629Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.072 194.622C344.937 194.913 344.802 195.206 344.667 195.498C344.361 195.338 343.802 195.124 343.796 195.024C343.778 194.719 343.978 194.453 344.098 194.172C344.421 194.324 344.747 194.471 345.072 194.622Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.693 194.487C379.56 194.815 379.425 195.142 379.291 195.47C379.001 195.359 378.47 195.239 378.466 195.136C378.456 194.821 378.652 194.51 378.77 194.197C379.078 194.296 379.385 194.39 379.693 194.487Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.853 189.298C413.678 189.481 413.502 189.666 413.323 189.852C412.968 189.621 412.56 189.411 412.3 189.141C412.239 189.074 412.66 188.796 412.86 188.615C413.186 188.841 413.514 189.065 413.853 189.298Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.349 174.663C442.236 175.031 442.108 175.444 441.983 175.858C441.749 175.832 441.322 175.88 441.324 175.76C441.328 175.414 441.506 174.998 441.618 174.609C441.855 174.626 442.094 174.644 442.349 174.663Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.163 154.973C471.429 155.111 471.757 155.189 471.924 155.426C471.975 155.502 471.6 155.994 471.422 156.294C471.129 156.157 470.788 156.071 470.58 155.849C470.535 155.8 470.955 155.277 471.163 154.973Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.659 127.293C498.52 127.618 498.377 127.948 498.233 128.278C497.963 128.183 497.649 128.147 497.455 127.952C497.408 127.904 497.745 127.324 497.906 126.988C498.153 127.089 498.402 127.19 498.659 127.293Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.319 97.998C521.234 98.5482 521.15 99.0984 521.066 99.6486C520.885 99.72 520.552 99.9678 520.55 99.8271C520.544 99.405 520.668 98.8317 520.742 98.3172C520.934 98.2122 521.125 98.1051 521.319 97.998Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.016 67.8191C540.918 68.1551 540.818 68.496 540.718 68.8355C540.498 68.7137 540.245 68.6528 540.081 68.4281C540.039 68.3735 540.284 67.7799 540.398 67.4355C540.6 67.5615 540.804 67.6889 541.016 67.8191Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.631 42.0068C558.547 42.3204 558.46 42.6417 558.376 42.9608C558.164 42.7971 557.927 42.69 557.766 42.4352C557.725 42.3764 557.943 41.8311 558.039 41.5098C558.233 41.6729 558.429 41.8367 558.631 42.0068Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.151 19.1456C574.114 19.5908 574.075 20.0948 574.033 20.5988C573.89 20.5652 573.635 20.6261 573.626 20.4791C573.598 20.057 573.669 19.5488 573.702 19.0742C573.847 19.0973 573.994 19.1204 574.151 19.1456Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.522 5.2675C588.498 5.7043 588.475 6.14179 588.455 6.57999C588.304 6.49879 588.045 6.45819 588.029 6.32799C587.984 5.93319 588.039 5.50549 588.055 5.0918C588.212 5.1485 588.365 5.2087 588.522 5.2675Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.399 1.25831C604.326 1.39691 604.256 1.5334 604.183 1.6713C603.952 1.30871 603.699 0.953807 603.518 0.575811C603.473 0.485512 603.669 0.328017 603.756 0.199219C603.966 0.547815 604.177 0.896412 604.399 1.25831Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41707 94.5696C9.05034 94.3365 8.68557 94.0992 8.3208 93.864C8.48357 93.7338 8.67576 93.4587 8.80128 93.5028C9.16212 93.633 9.49747 93.8955 9.84263 94.1055C9.70143 94.2588 9.55827 94.4142 9.41707 94.5696Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2251 98.01C29.6075 97.905 29.9801 97.7622 30.3822 97.7286C30.4685 97.7202 30.7724 98.1297 30.7763 98.3061C30.7783 98.4846 30.49 98.7786 30.3998 98.7366C29.9939 98.5518 29.6134 98.262 29.2251 98.01Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3707 101.297C51.9941 101.343 51.6268 101.436 51.2326 101.402C51.1208 101.392 50.9306 101.009 50.7756 100.797C51.1744 100.743 51.5627 100.65 51.9778 100.659C52.053 100.661 52.2354 101.072 52.3707 101.297Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.579 107.226C73.1554 106.93 72.7318 106.634 72.3088 106.338C72.4677 106.235 72.6442 105.987 72.7834 106.054C73.1887 106.245 73.5836 106.56 73.9817 106.827C73.8483 106.959 73.715 107.092 73.579 107.226Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1643 113.257C97.7897 113.272 97.4308 113.333 97.0288 113.265C96.915 113.247 96.6816 112.852 96.5012 112.629C96.8974 112.604 97.2778 112.547 97.6955 112.589C97.7701 112.598 98.0034 113.024 98.1643 113.257Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.396 121.678C120.031 121.68 119.682 121.73 119.284 121.648C119.171 121.627 118.914 121.228 118.721 120.999C119.108 120.991 119.478 120.947 119.892 121.001C119.967 121.012 120.224 121.44 120.396 121.678Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.592 127.952C144.251 127.967 143.935 128.037 143.551 127.965C143.422 127.94 143.12 127.556 142.898 127.337C143.255 127.31 143.592 127.239 143.99 127.285C144.077 127.295 144.384 127.719 144.592 127.952Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.154 136.365C165.83 136.373 165.532 136.434 165.159 136.356C165.032 136.327 164.714 135.942 164.483 135.722C164.824 135.703 165.14 135.642 165.524 135.695C165.608 135.705 165.936 136.129 166.154 136.365Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.013 144.811C188.69 144.792 188.394 144.817 188.025 144.716C187.918 144.687 187.601 144.286 187.384 144.055C187.721 144.067 188.038 144.048 188.416 144.128C188.483 144.143 188.805 144.573 189.013 144.811Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.563 156.023C210.257 155.994 209.978 156.011 209.623 155.904C209.523 155.872 209.2 155.471 208.978 155.242C209.3 155.265 209.598 155.257 209.959 155.345C210.024 155.362 210.353 155.786 210.563 156.023Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.451 164.412C231.171 164.387 230.919 164.41 230.586 164.305C230.49 164.276 230.152 163.883 229.927 163.656C230.222 163.673 230.492 163.658 230.829 163.742C230.888 163.757 231.233 164.177 231.451 164.412Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.333 172.813C252.072 172.785 251.84 172.8 251.526 172.695C251.438 172.666 251.104 172.279 250.883 172.055C251.157 172.08 251.405 172.072 251.723 172.158C251.779 172.173 252.121 172.582 252.333 172.813Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.28 181.199C269.043 181.174 268.837 181.193 268.549 181.094C268.468 181.066 268.141 180.689 267.927 180.471C268.174 180.492 268.396 180.481 268.688 180.561C268.739 180.576 269.074 180.976 269.28 181.199Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.694 193.229C297.279 193.135 296.891 193.082 296.434 192.912C296.308 192.866 295.972 192.473 295.732 192.238C296.166 192.337 296.579 192.402 297.053 192.555C297.135 192.583 297.471 192.994 297.694 193.229Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.34 201.37C331.948 201.399 331.586 201.473 331.142 201.424C330.993 201.41 330.64 201.095 330.379 200.916C330.792 200.88 331.177 200.809 331.636 200.83C331.736 200.834 332.098 201.179 332.34 201.37Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.948 204.002C368.533 204.113 368.142 204.258 367.683 204.304C367.553 204.317 367.225 204.046 366.987 203.905C367.423 203.785 367.842 203.64 368.317 203.565C368.402 203.552 368.731 203.848 368.948 204.002Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.94 200.935C402.545 201.163 402.18 201.424 401.735 201.592C401.584 201.649 401.237 201.466 400.979 201.392C401.395 201.147 401.785 200.874 402.248 200.67C402.348 200.626 402.702 200.84 402.94 200.935Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.357 190.975C431.939 191.292 431.541 191.637 431.081 191.899C430.952 191.971 430.63 191.805 430.396 191.75C430.839 191.414 431.261 191.059 431.737 190.761C431.822 190.709 432.143 190.898 432.357 190.975Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.12 173.73C460.72 174.219 460.344 174.736 459.895 175.179C459.745 175.328 459.41 175.295 459.159 175.345C459.584 174.822 459.983 174.278 460.448 173.783C460.55 173.675 460.888 173.743 461.12 173.73Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.954 151.024C488.368 150.412 488.756 149.785 489.213 149.199C489.311 149.075 489.786 148.972 489.843 149.106C489.898 149.243 489.654 149.871 489.537 149.965C489.011 150.381 488.484 150.681 487.954 151.024Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.922 120.285C513.588 120.892 513.28 121.524 512.904 122.088C512.776 122.278 512.478 122.292 512.259 122.385C512.612 121.737 512.941 121.07 513.329 120.448C513.414 120.312 513.718 120.335 513.922 120.285Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.386 91.584C535.102 92.1958 534.841 92.8342 534.515 93.3991C534.405 93.5909 534.135 93.5951 533.939 93.684C534.239 93.0267 534.519 92.3547 534.853 91.7289C534.927 91.5924 535.202 91.6274 535.386 91.584Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.952 64.4971C552.689 65.0704 552.444 65.671 552.149 66.1918C552.067 66.3367 551.836 66.2338 551.673 66.2443C551.947 65.6332 552.208 65.0053 552.512 64.4341C552.565 64.3354 552.799 64.4698 552.952 64.4971Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.905 39.3713C569.679 39.8753 569.479 40.4191 569.216 40.8727C569.128 41.0239 568.885 40.9441 568.712 40.9714C568.948 40.4192 569.163 39.848 569.432 39.3419C569.491 39.2327 569.742 39.3545 569.905 39.3713Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.574 21.5156C585.35 21.8852 585.146 22.2968 584.888 22.6097C584.815 22.7 584.581 22.5026 584.422 22.4396C584.657 22.0322 584.88 21.6038 585.144 21.2489C585.19 21.1859 585.425 21.419 585.574 21.5156Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.132 11.8027C600.788 11.7229 600.445 11.6473 600.1 11.5738C600.171 11.3953 600.214 11.074 600.318 11.0677C600.622 11.053 600.953 11.1643 601.273 11.2315C601.226 11.4205 601.179 11.6095 601.132 11.8027Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.652 13.8443C617.411 13.8401 617.189 13.8821 616.912 13.8149C616.832 13.7939 616.579 13.4433 616.407 13.2438C616.659 13.2291 616.895 13.1913 617.179 13.2438C617.23 13.2543 617.489 13.6343 617.652 13.8443Z",
    fill: "#CCB7B7",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNotification);
export default __webpack_public_path__ + "static/media/bgNotification.4c350aba240a372c42bca366c68ad779.svg";
export { ForwardRef as ReactComponent };